import React from 'react';

/* eslint-disable max-len */

interface Svg extends React.SVGProps<SVGSVGElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function Svg({
  children,
  className = '',
  viewBox = '0 0 24 24',
  style = {},
  ...props
}: Svg): React.JSX.Element {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      height="1em"
      width="1em"
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconDockToLeft(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_599_9869"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_599_9869)">
        <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" />
      </g>
    </Svg>
  );
}

export function IconDockToRight(props: Partial<Svg>) {
  return (
    <IconDockToLeft
      {...props}
      style={{ transform: 'scale(-1, 1)', ...(props?.style || {}) }}
    />
  );
}

export function IconNotificationOff(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
      <mask
        id="mask0_1004_8935"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1004_8935)">
        <path
          d="M4.00002 19V17H6.00002V10C6.00002 9.45 6.07086 8.90833 6.21252 8.375C6.35419 7.84167 6.56669 7.33333 6.85002 6.85L8.35003 8.35C8.23336 8.61667 8.14586 8.8875 8.08752 9.1625C8.02919 9.4375 8.00002 9.71667 8.00002 10V17H14.2L1.40002 4.2L2.80002 2.8L21.2 21.2L19.8 22.6L16.15 19H4.00002ZM18 15.15L16 13.15V10C16 8.9 15.6084 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C11.5667 6 11.15 6.06667 10.75 6.2C10.35 6.33333 9.98336 6.53333 9.65003 6.8L8.20003 5.35C8.53336 5.08333 8.89169 4.85 9.27502 4.65C9.65836 4.45 10.0667 4.3 10.5 4.2V3.5C10.5 3.08333 10.6459 2.72917 10.9375 2.4375C11.2292 2.14583 11.5834 2 12 2C12.4167 2 12.7709 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8334 4.53333 15.9167 5.2375 16.75 6.3125C17.5834 7.3875 18 8.61667 18 10V15.15ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1959 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0209 21.8042 12.55 22 12 22Z"
          fill="currentColor" // #555555
        />
      </g>
      {/* </svg> */}
    </Svg>
  );
}
export function IconFrontHand(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1004_8940"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1004_8940)">
        <path
          d="M12 12V2C12 1.71667 12.0958 1.47917 12.2875 1.2875C12.4792 1.09583 12.7167 1 13 1C13.2833 1 13.5208 1.09583 13.7125 1.2875C13.9042 1.47917 14 1.71667 14 2V12H12ZM8 12V3C8 2.71667 8.09583 2.47917 8.2875 2.2875C8.47917 2.09583 8.71667 2 9 2C9.28333 2 9.52083 2.09583 9.7125 2.2875C9.90417 2.47917 10 2.71667 10 3V12H8ZM12.5 23C10.1333 23 8.125 22.175 6.475 20.525C4.825 18.875 4 16.8667 4 14.5V5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4C5.28333 4 5.52083 4.09583 5.7125 4.2875C5.90417 4.47917 6 4.71667 6 5V14.5C6 16.3167 6.62917 17.8542 7.8875 19.1125C9.14583 20.3708 10.6833 21 12.5 21C14.3167 21 15.8542 20.3708 17.1125 19.1125C18.3708 17.8542 19 16.3167 19 14.5V11C18.7167 11 18.4792 11.0958 18.2875 11.2875C18.0958 11.4792 18 11.7167 18 12V16H15C14.45 16 13.9792 16.1958 13.5875 16.5875C13.1958 16.9792 13 17.45 13 18V19H11V18C11 16.9 11.3917 15.9583 12.175 15.175C12.9583 14.3917 13.9 14 15 14H16V4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3C17.2833 3 17.5208 3.09583 17.7125 3.2875C17.9042 3.47917 18 3.71667 18 4V9.175C18.1667 9.125 18.3292 9.08333 18.4875 9.05C18.6458 9.01667 18.8167 9 19 9H21V14.5C21 16.8667 20.175 18.875 18.525 20.525C16.875 22.175 14.8667 23 12.5 23Z"
          fill="currentColor"
        />
      </g>
    </Svg>
  );
}
export function IconReply(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4226"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4226)">
        <path
          d="M12.6667 12.6663V9.99967C12.6667 9.44412 12.4722 8.9719 12.0833 8.58301C11.6944 8.19412 11.2222 7.99967 10.6667 7.99967H4.55L6.95 10.3997L6 11.333L2 7.33301L6 3.33301L6.95 4.26634L4.55 6.66634H10.6667C11.5889 6.66634 12.375 6.99134 13.025 7.64134C13.675 8.29134 14 9.07745 14 9.99967V12.6663H12.6667Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconContentCopy(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4231"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4231)">
        <path
          d="M6 11.9997C5.63333 11.9997 5.31944 11.8691 5.05833 11.608C4.79722 11.3469 4.66667 11.033 4.66667 10.6663V2.66634C4.66667 2.29967 4.79722 1.98579 5.05833 1.72467C5.31944 1.46356 5.63333 1.33301 6 1.33301H12C12.3667 1.33301 12.6806 1.46356 12.9417 1.72467C13.2028 1.98579 13.3333 2.29967 13.3333 2.66634V10.6663C13.3333 11.033 13.2028 11.3469 12.9417 11.608C12.6806 11.8691 12.3667 11.9997 12 11.9997H6ZM6 10.6663H12V2.66634H6V10.6663ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967H3.33333V13.333H10.6667V14.6663H3.33333Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconPencilEdit(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4236"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4236)">
        <path
          d="M1.33337 15.9997V13.333H14.6667V15.9997H1.33337ZM4.00004 10.6663H4.93337L10.1334 5.48301L9.18337 4.53301L4.00004 9.73301V10.6663ZM2.66671 11.9997V9.16634L10.1334 1.71634C10.2556 1.59412 10.3973 1.49967 10.5584 1.43301C10.7195 1.36634 10.8889 1.33301 11.0667 1.33301C11.2445 1.33301 11.4167 1.36634 11.5834 1.43301C11.75 1.49967 11.9 1.59967 12.0334 1.73301L12.95 2.66634C13.0834 2.78856 13.1806 2.93301 13.2417 3.09967C13.3028 3.26634 13.3334 3.43856 13.3334 3.61634C13.3334 3.78301 13.3028 3.9469 13.2417 4.10801C13.1806 4.26912 13.0834 4.41634 12.95 4.54967L5.50004 11.9997H2.66671Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconForward(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4241)">
        <path
          d="M3.99996 15.3337C3.63329 15.3337 3.3194 15.2031 3.05829 14.942C2.79718 14.6809 2.66663 14.367 2.66663 14.0003V6.66699C2.66663 6.30033 2.79718 5.98644 3.05829 5.72533C3.3194 5.46421 3.63329 5.33366 3.99996 5.33366H5.99996V6.66699H3.99996V14.0003H12V6.66699H9.99996V5.33366H12C12.3666 5.33366 12.6805 5.46421 12.9416 5.72533C13.2027 5.98644 13.3333 6.30033 13.3333 6.66699V14.0003C13.3333 14.367 13.2027 14.6809 12.9416 14.942C12.6805 15.2031 12.3666 15.3337 12 15.3337H3.99996ZM7.33329 10.667V3.21699L6.26663 4.28366L5.33329 3.33366L7.99996 0.666992L10.6666 3.33366L9.73329 4.28366L8.66663 3.21699V10.667H7.33329Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconDelete(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4247"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4247)">
        <path
          d="M4.66663 14C4.29996 14 3.98607 13.8694 3.72496 13.6083C3.46385 13.3472 3.33329 13.0333 3.33329 12.6667V4H2.66663V2.66667H5.99996V2H9.99996V2.66667H13.3333V4H12.6666V12.6667C12.6666 13.0333 12.5361 13.3472 12.275 13.6083C12.0138 13.8694 11.7 14 11.3333 14H4.66663ZM11.3333 4H4.66663V12.6667H11.3333V4ZM5.99996 11.3333H7.33329V5.33333H5.99996V11.3333ZM8.66663 11.3333H9.99996V5.33333H8.66663V11.3333Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconPlus(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_1070_4517"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1070_4517)">
        <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="#555555" />
      </g>
    </Svg>
  );
}
export function IconGoogle(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1461_7)">
        <path
          d="M8.36068 1.70594C5.9627 2.53781 3.89469 4.11675 2.46041 6.21081C1.02612 8.30488 0.30116 10.8037 0.392005 13.3402C0.482851 15.8768 1.38472 18.3173 2.96513 20.3034C4.54555 22.2895 6.72121 23.7165 9.17255 24.3747C11.1599 24.8875 13.2421 24.91 15.2401 24.4403C17.05 24.0338 18.7234 23.1641 20.0963 21.9166C21.5252 20.5785 22.5624 18.8762 23.0963 16.9928C23.6767 14.9447 23.7799 12.7908 23.3982 10.6966H12.2382V15.3259H18.7013C18.5721 16.0643 18.2953 16.769 17.8875 17.3979C17.4796 18.0268 16.949 18.5669 16.3276 18.9859C15.5383 19.508 14.6487 19.8593 13.7157 20.0172C12.7799 20.1912 11.8202 20.1912 10.8844 20.0172C9.93603 19.8211 9.03886 19.4297 8.25005 18.8678C6.98283 17.9708 6.03132 16.6964 5.5313 15.2266C5.02283 13.7292 5.02283 12.1058 5.5313 10.6084C5.88722 9.55884 6.47561 8.60319 7.25255 7.81281C8.14166 6.89171 9.2673 6.23331 10.506 5.90983C11.7446 5.58635 13.0485 5.61031 14.2744 5.97906C15.2321 6.27305 16.1079 6.78669 16.8319 7.47906C17.5607 6.75406 18.2882 6.02719 19.0144 5.29844C19.3894 4.90656 19.7982 4.53344 20.1676 4.13219C19.0624 3.1037 17.7651 2.30342 16.35 1.77719C13.7732 0.841542 10.9538 0.816398 8.36068 1.70594Z"
          fill="#282C35"
        />
        <path
          d="M8.36058 1.70587C10.9535 0.815728 13.7729 0.840211 16.35 1.77525C17.7652 2.30505 19.0619 3.10919 20.1656 4.1415C19.7906 4.54275 19.395 4.91775 19.0125 5.30775C18.285 6.034 17.5581 6.75775 16.8318 7.479C16.1078 6.78663 15.232 6.27298 14.2743 5.979C13.0488 5.60895 11.745 5.58361 10.506 5.90576C9.26699 6.22792 8.14067 6.88511 7.25058 7.80525C6.47364 8.59563 5.88525 9.55128 5.52933 10.6009L1.64246 7.5915C3.03372 4.83255 5.44261 2.72217 8.36058 1.70587Z"
          fill="#E33629"
        />
        <path
          d="M0.611279 10.5728C0.820194 9.53742 1.16704 8.53473 1.64253 7.59155L5.5294 10.6084C5.02093 12.1058 5.02093 13.7292 5.5294 15.2266C4.2344 16.2266 2.93878 17.2316 1.64253 18.2416C0.452186 15.8721 0.0891526 13.1725 0.611279 10.5728Z"
          fill="#F8BD00"
        />
        <path
          d="M12.2381 10.6946H23.3981C23.7799 12.7888 23.6766 14.9427 23.0963 16.9908C22.5623 18.8742 21.5252 20.5765 20.0963 21.9146C18.8419 20.9358 17.5819 19.9646 16.3275 18.9858C16.9494 18.5664 17.4802 18.0256 17.8881 17.3961C18.296 16.7665 18.5726 16.0611 18.7013 15.3221H12.2381C12.2363 13.7808 12.2381 12.2377 12.2381 10.6946Z"
          fill="#587DBD"
        />
        <path
          d="M1.64062 18.2416C2.93687 17.2416 4.2325 16.2366 5.5275 15.2266C6.02851 16.6969 6.98138 17.9714 8.25 18.8678C9.04127 19.4271 9.94037 19.8153 10.89 20.0078C11.8257 20.1818 12.7855 20.1818 13.7213 20.0078C14.6542 19.8499 15.5439 19.4986 16.3331 18.9766C17.5875 19.9553 18.8475 20.9266 20.1019 21.9053C18.7292 23.1535 17.0558 24.0238 15.2456 24.4309C13.2476 24.9006 11.1655 24.8781 9.17813 24.3653C7.60632 23.9456 6.13814 23.2058 4.86563 22.1922C3.51874 21.1229 2.41867 19.7753 1.64062 18.2416Z"
          fill="#319F43"
        />
      </g>
      <defs>
        <clipPath id="clip0_1461_7">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.916504)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function IconFaceBook(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12.9165C22 7.3965 17.52 2.9165 12 2.9165C6.48 2.9165 2 7.3965 2 12.9165C2 17.7565 5.44 21.7865 10 22.7165V15.9165H8V12.9165H10V10.4165C10 8.4865 11.57 6.9165 13.5 6.9165H16V9.9165H14C13.45 9.9165 13 10.3665 13 10.9165V12.9165H16V15.9165H13V22.8665C18.05 22.3665 22 18.1065 22 12.9165Z"
        fill="#4365BA"
      />
    </Svg>
  );
}
export function IconTipping(props: Partial<Svg>) {
  return (
    <Svg
      width="50"
      height="46"
      viewBox="0 0 50 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_883_88716)">
        <rect
          x="22.1754"
          y="0.083252"
          width="27.8246"
          height="5.62595"
          fill="#11B559"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.9999 10.0035H0V15.6295H22.1753L22.1753 45.9001H27.8247V15.6295H49.9999V10.0035Z"
          fill="#282C35"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.9999 19.9237H32.1496V25.5497H44.3505V30.5101L32.0841 40.3272H27.8241V45.8989L34.6901 45.9165L49.9999 33.2176V25.5497V23.3985V19.9237Z"
          fill="#11B559"
        />
      </g>
      <defs>
        <clipPath id="clip0_883_88716">
          <rect
            width="50"
            height="45.8333"
            fill="white"
            transform="translate(0 0.083252)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
}

export function IconTippingLogoMobile(props: Partial<Svg>) {
  return (
    <svg
      width="31"
      height="28"
      viewBox="0 0 31 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1269_32722)">
        <rect x="13.8052" width="16.6948" height="3.38784" fill="#11B559" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5 5.97388H0.5V9.36172H13.8052L13.8052 27.5902H17.1948V9.36172H30.5V5.97388Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5 11.9476H19.7899V15.3355H27.1104V18.3226L19.7506 24.2343H17.1946V27.5894L21.3142 27.6L30.5 19.953V15.3355V14.0401V11.9476Z"
          fill="#11B559"
        />
      </g>
      <defs>
        <clipPath id="clip0_1269_32722">
          <rect
            width="30"
            height="27.6"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconCommunity(props: Partial<Svg>) {
  return (
    <Svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4167 3.7572H4.58333C4.0971 3.7572 3.63079 3.95036 3.28697 4.29417C2.94315 4.63799 2.75 5.10431 2.75 5.59054V19.3405L5.92808 16.9572C6.24543 16.7192 6.6314 16.5905 7.02808 16.5905H17.4167C17.9029 16.5905 18.3692 16.3974 18.713 16.0536C19.0568 15.7097 19.25 15.2434 19.25 14.7572V5.59054C19.25 5.10431 19.0568 4.63799 18.713 4.29417C18.3692 3.95036 17.9029 3.7572 17.4167 3.7572Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
export function IconSuccess(props: Partial<Svg>) {
  return (
    <Svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.181152" width="32" height="32" rx="16" fill="#11B559" />
      <g clipPath="url(#clip0_1395_18538)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3711 23.2173L16.3636 23.2186L16.3192 23.2404L16.3067 23.2429L16.298 23.2404L16.2536 23.2179C16.2469 23.2163 16.2419 23.2175 16.2386 23.2217L16.2361 23.2279L16.2255 23.4954L16.2286 23.5079L16.2349 23.5161L16.2999 23.5623L16.3092 23.5648L16.3167 23.5623L16.3817 23.5161L16.3892 23.5061L16.3917 23.4954L16.3811 23.2286C16.3794 23.2219 16.3761 23.2181 16.3711 23.2173ZM16.5361 23.1467L16.5274 23.1479L16.4124 23.2061L16.4061 23.2123L16.4042 23.2192L16.4155 23.4879L16.4186 23.4954L16.4236 23.5004L16.5492 23.5579C16.5572 23.56 16.5632 23.5583 16.5674 23.5529L16.5699 23.5442L16.5486 23.1604C16.5465 23.1525 16.5424 23.1479 16.5361 23.1467ZM16.0892 23.1479C16.0865 23.1463 16.0832 23.1457 16.08 23.1464C16.0769 23.1471 16.0742 23.149 16.0724 23.1517L16.0686 23.1604L16.0474 23.5442C16.0478 23.5517 16.0513 23.5567 16.058 23.5592L16.0674 23.5579L16.193 23.4998L16.1992 23.4948L16.2011 23.4879L16.2124 23.2192L16.2105 23.2117L16.2042 23.2054L16.0892 23.1479Z"
          fill="white"
          fillOpacity="0.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6843 10.6392C20.8227 10.5559 20.9881 10.5295 21.1457 10.5655C21.3032 10.6015 21.4407 10.6972 21.5293 10.8324L22.148 11.7761C22.2287 11.8994 22.2632 12.0472 22.2455 12.1935C22.2277 12.3397 22.1589 12.475 22.0511 12.5755L22.0493 12.578L22.0405 12.5861L22.0049 12.6192L21.8643 12.7536C21.0862 13.5084 20.3316 14.2871 19.6018 15.0886C18.2286 16.5986 16.598 18.5749 15.5005 20.4924C15.1943 21.0274 14.4461 21.1424 14.0024 20.6805L9.94926 16.4692C9.89118 16.4089 9.84582 16.3374 9.81589 16.2592C9.78597 16.1809 9.77208 16.0975 9.77505 16.0137C9.77803 15.93 9.7978 15.8477 9.8332 15.7718C9.86861 15.6959 9.91891 15.6278 9.98113 15.5717L11.2061 14.4667C11.3138 14.3697 11.4518 14.3131 11.5966 14.3066C11.7414 14.3001 11.884 14.3441 11.9999 14.4311L14.068 15.9817C17.2986 12.7961 19.1305 11.5736 20.6843 10.6392Z"
          fill="white"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1395_18538">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(8.5 8.68115)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
}
export function IconArrow(props: Partial<Svg>) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.06699 12.607L11.167 2.52599L11.167 11.818H12.167L12.167 0.817993L1.16699 0.817993V1.81799L10.46 1.81799L0.378992 11.918L1.06699 12.607Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function IconArrowRight(props: Partial<Svg>) {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.25 6.28146V1.69229L17.902 7.19812L9.25 12.704V8.11479V7.61479H8.75H1V6.78146H8.75H9.25V6.28146Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
}

export function IconArrowLeft(props: Partial<Svg>) {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2021_2615)">
        <path
          d="M12.5 5.18115H3.5C3.22 5.18115 3 4.96115 3 4.68115C3 4.40115 3.22 4.18115 3.5 4.18115H12.5C12.78 4.18115 13 4.40115 13 4.68115C13 4.96115 12.78 5.18115 12.5 5.18115Z"
          fill="black"
        />
        <path
          d="M6 8.68115C5.93442 8.68195 5.86941 8.66902 5.80913 8.64319C5.74885 8.61735 5.69465 8.57919 5.65 8.53115L2.15 5.03115C1.95 4.83115 1.95 4.52115 2.15 4.32115L5.65 0.831152C5.85 0.631152 6.16 0.631152 6.36 0.831152C6.56 1.03115 6.56 1.34115 6.36 1.54115L3.21 4.69115L6.36 7.84115C6.56 8.04115 6.56 8.35115 6.36 8.55115C6.26 8.65115 6.13 8.70115 6.01 8.70115L6 8.68115Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2021_2615">
          <rect
            width="16"
            height="9"
            fill="white"
            transform="translate(0 0.181152)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Arrow(props: Partial<Svg>) {
  return (
    <Svg
      width="32"
      height="32"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.083 10.0835V5.49433L19.735 11.0002L11.083 16.506V11.9168V11.4168H10.583H2.83301V10.5835H10.583H11.083V10.0835Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </Svg>
  );
}

export function ArrowTopRight(props: Partial<Svg>) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <path
        d="M7.4 18.1159L17.5 8.0349V17.3269H18.5V6.3269L7.5 6.3269V7.3269L16.793 7.3269L6.712 17.4269L7.4 18.1159Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Polygon3(props: Partial<Svg>) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 37 42"
      fill="none"
      {...props}
    >
      <path
        d="M36.5498 21.0199L0.62158 41.7631L0.621582 0.276726L36.5498 21.0199Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Search(props: Partial<Svg>) {
  return (
    <Svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 19.85L15.5833 16.1833M17.4167 10.6833C17.4167 12.6282 16.6441 14.4935 15.2688 15.8688C13.8935 17.244 12.0283 18.0166 10.0833 18.0166C8.13841 18.0166 6.27315 17.244 4.89788 15.8688C3.52262 14.4935 2.75 12.6282 2.75 10.6833C2.75 8.73839 3.52262 6.87313 4.89788 5.49786C6.27315 4.12259 8.13841 3.34998 10.0833 3.34998C12.0283 3.34998 13.8935 4.12259 15.2688 5.49786C16.6441 6.87313 17.4167 8.73839 17.4167 10.6833Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
export function Coin(props: Partial<Svg>) {
  return (
    <Svg
      width="101"
      height="102"
      viewBox="0 0 101 102"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="rotate(-38, 50, 50)">
        <path
          d="M82.6387 18.2575C81.3837 17.2649 80.0746 16.3812 78.7287 15.5844C77.5944 14.4115 76.4586 13.3693 75.2639 12.4243C69.262 7.67715 62.1215 5.17034 54.7088 4.73807C54.7066 4.73833 54.7032 4.73761 54.701 4.73787C50.9414 4.51958 47.1118 4.8394 43.3228 5.6688C43.2232 5.67596 43.1316 5.70339 43.0353 5.72914C39.4244 6.54556 35.8553 7.83461 32.4239 9.56834C32.3409 9.60258 32.264 9.64167 32.1872 9.69081C29.8018 10.9131 27.4834 12.3462 25.2663 13.9973C25.1176 14.0716 24.991 14.1812 24.8681 14.3038C21.5522 16.8262 18.4641 19.8185 15.7274 23.2785C11.4469 28.6904 8.45955 34.6676 6.72801 40.7749C6.70439 40.8401 6.68368 40.9017 6.67035 40.969C5.65857 44.5925 5.09369 48.2598 4.96519 51.8806C4.96109 51.9793 4.94546 52.0748 4.9602 52.1724C4.85531 55.8139 5.19949 59.4029 5.98124 62.8505C5.98851 62.9702 6.02388 63.0821 6.05854 63.1974C7.95213 71.2289 12.2396 78.4644 18.877 83.7143C20.0717 84.6592 21.3475 85.5244 22.7501 86.3581C23.8354 87.4843 24.9968 88.5548 26.2518 89.5474C43.5347 103.217 70.2419 98.3484 85.7882 78.6932C101.334 59.0381 99.9216 31.9274 82.6387 18.2575ZM67.0812 11.1972C66.529 11.0921 65.9758 10.9983 65.4185 10.9172C65.0803 10.8674 64.7415 10.8132 64.402 10.7725C63.9009 10.7139 63.3985 10.6721 62.8941 10.6328L60.5268 8.76036C62.9887 9.34097 65.3894 10.1608 67.6706 11.2958C67.4763 11.256 67.2775 11.2346 67.0812 11.1972ZM12.5487 54.7318L8.13974 51.2445C8.26699 48.8556 8.60634 46.4485 9.14617 44.0482L13.8021 47.7309C13.65 48.3198 13.5079 48.9088 13.3792 49.4983C13.3238 49.7503 13.2763 50.0024 13.2253 50.2538C13.0857 50.9506 12.9628 51.6466 12.8556 52.343C12.8151 52.5988 12.7713 52.8538 12.7352 53.109C12.6601 53.6511 12.6027 54.1911 12.5487 54.7318ZM32.8855 12.8726L37.5894 16.5932C36.9472 16.9604 36.3125 17.3435 35.6852 17.7425C35.5128 17.8519 35.3413 17.9601 35.1701 18.0704C34.5739 18.458 33.9872 18.8612 33.4043 19.2773L28.6033 15.4799C29.9965 14.5218 31.426 13.6543 32.8855 12.8726ZM18.1857 25.2229C18.841 24.3944 19.5307 23.6133 20.226 22.8404L25.1265 26.7165C25.1097 26.7352 25.0942 26.7549 25.0774 26.7736C24.4039 27.5317 23.741 28.3041 23.1023 29.1116C22.7766 29.5234 22.4686 29.9431 22.1571 30.3622L17.2615 26.4899C17.5726 26.0687 17.8581 25.6371 18.1857 25.2229ZM20.3529 32.9313C19.9903 33.4857 19.6441 34.0471 19.3061 34.6109C19.2818 34.6517 19.2541 34.6917 19.2289 34.7337C18.7793 35.489 18.3543 36.2538 17.9476 37.0231L13.0999 33.1888C13.8149 31.7922 14.5968 30.4146 15.4658 29.0658L20.3529 32.9313ZM30.8368 21.2426C30.6892 21.3636 30.5454 21.4897 30.399 21.6117C30.2385 21.7465 30.0789 21.88 29.9196 22.0158C29.1591 22.669 28.4097 23.3411 27.6811 24.0476C27.647 24.0806 27.6144 24.1167 27.5794 24.151C27.4832 24.2447 27.392 24.3424 27.2958 24.4362L22.4174 20.5776C23.5693 19.4546 24.7507 18.3829 25.9829 17.4035L30.8368 21.2426ZM16.5477 39.912C16.4663 40.0934 16.3814 40.274 16.3023 40.4572C16.2741 40.5208 16.2436 40.5846 16.2165 40.6491C15.8263 41.5593 15.4704 42.4766 15.1394 43.3977C15.0702 43.5888 15.0057 43.7815 14.939 43.9745C14.8788 44.1467 14.8173 44.3178 14.7593 44.4897L10.0222 40.7429C10.5003 39.181 11.0738 37.6324 11.7305 36.0998L16.5477 39.912ZM44.0679 13.4952C43.8278 13.589 43.5897 13.6905 43.3502 13.7887C42.6972 14.0535 42.0472 14.3346 41.4022 14.6297C41.1693 14.7372 40.935 14.8416 40.7026 14.9535C40.674 14.9668 40.6464 14.979 40.6191 14.9933L36.0111 11.3486C38.3288 10.3306 40.6985 9.53742 43.0906 8.95586L47.3963 12.3614C47.0762 12.4579 46.7569 12.551 46.4388 12.6551C45.6455 12.9128 44.8536 13.1915 44.0679 13.4952ZM54.3505 7.87139L57.7466 10.5575C57.233 10.5829 56.7175 10.6107 56.2015 10.6542C55.7653 10.6929 55.3297 10.7459 54.8939 10.7968C54.4614 10.8484 54.0295 10.9044 53.5977 10.9704C53.1756 11.0342 52.7542 11.0945 52.3334 11.1693C51.963 11.236 51.5953 11.3168 51.225 11.3935L47.1663 8.18336C49.5724 7.85454 51.9759 7.74357 54.3505 7.87139ZM8.10176 55.2107L12.3202 58.5472C12.3152 58.839 12.308 59.131 12.3096 59.422C12.3123 60.1815 12.3336 60.9376 12.3758 61.6902C12.3989 62.1182 12.436 62.5411 12.4734 62.9663C12.5108 63.4015 12.5536 63.835 12.603 64.2677C12.6228 64.4472 12.6341 64.63 12.6571 64.808L8.95987 61.8837C8.48427 59.7112 8.19803 57.4787 8.10176 55.2107ZM16.0299 76.585C13.6811 73.7621 11.8789 70.5664 10.5652 67.1496L13.5385 69.5014C13.5988 69.7409 13.6677 69.9772 13.7312 70.2152C13.8394 70.6165 13.9441 71.017 14.0641 71.4136C14.2787 72.1249 14.5127 72.8294 14.7667 73.5239C14.8847 73.847 15.0152 74.162 15.1416 74.4797C15.3488 75.0033 15.5666 75.5212 15.797 76.0332C15.8798 76.2166 15.9464 76.4051 16.0299 76.585ZM28.1961 87.0891C27.2202 86.3172 26.301 85.4963 25.435 84.6334L25.0005 84.1799C24.9471 84.1236 24.8946 84.0661 24.8402 84.0111C24.4601 83.6126 24.0924 83.2059 23.735 82.7913C23.7091 82.7609 23.6845 82.7314 23.6586 82.7009C23.311 82.2941 22.9739 81.8816 22.6493 81.461C22.6059 81.4047 22.5647 81.3481 22.5235 81.2916C22.2205 80.8941 21.9248 80.4924 21.6416 80.0825C21.5651 79.9721 21.495 79.8586 21.4207 79.7479C21.1766 79.3871 20.9357 79.0247 20.7085 78.6552C20.5463 78.393 20.3955 78.1238 20.2418 77.8584C20.1093 77.6318 19.9728 77.4078 19.8467 77.1782C15.4515 69.1542 14.3197 59.3235 16.5433 49.6612C16.5643 49.5739 16.5866 49.4877 16.6077 49.4004C16.7315 48.875 16.8642 48.3485 17.0094 47.824C17.0657 47.6188 17.129 47.4151 17.1888 47.2106C17.3065 46.8042 17.4276 46.3984 17.5565 45.9929C17.6393 45.7367 17.7277 45.4809 17.8149 45.2242C17.9346 44.8733 18.0565 44.5221 18.185 44.1702C18.2891 43.8869 18.398 43.6053 18.509 43.3235C18.6352 42.9997 18.7648 42.6767 18.8989 42.3531C19.0208 42.06 19.1475 41.7685 19.2753 41.478C19.4119 41.1664 19.5541 40.8553 19.6997 40.5449C19.8361 40.2512 19.976 39.9582 20.1214 39.6656C20.272 39.3591 20.4294 39.054 20.588 38.7499C20.7384 38.4612 20.8897 38.1713 21.046 37.8853C21.2151 37.5755 21.3923 37.2681 21.5705 36.9595C21.7291 36.6832 21.8866 36.4082 22.052 36.1334C22.2472 35.8083 22.454 35.4863 22.6585 35.1646C22.8177 34.9128 22.9734 34.6603 23.1385 34.4112C23.3792 34.0462 23.6318 33.6865 23.8853 33.3256C24.0279 33.1226 24.1635 32.9182 24.3085 32.7172C24.7098 32.1594 25.1269 31.6042 25.5605 31.056C25.9941 30.5078 26.4383 29.974 26.8892 29.4494C27.0514 29.2621 27.22 29.0817 27.3837 28.8975C27.6756 28.5689 27.9684 28.2391 28.2682 27.9207C28.4726 27.7027 28.6824 27.493 28.8907 27.2802C29.1567 27.007 29.4237 26.7326 29.6939 26.4668C29.9222 26.2438 30.1557 26.0269 30.3868 25.808C30.6451 25.5648 30.9047 25.3225 31.167 25.0844C31.4103 24.8652 31.6565 24.6524 31.9028 24.4395C32.1622 24.2151 32.4241 23.9927 32.6865 23.7746C32.9379 23.5679 33.1908 23.3643 33.445 23.1617C33.7135 22.9485 33.9838 22.7407 34.2553 22.5338C34.5095 22.3413 34.763 22.1522 35.0202 21.966C35.3029 21.76 35.5887 21.5604 35.8747 21.3631C36.1241 21.1967 36.3728 21.0238 36.6235 20.8584C36.9342 20.6525 37.2478 20.4531 37.5639 20.2555C37.7937 20.1115 38.021 19.9656 38.2525 19.827C38.6162 19.6072 38.9843 19.3969 39.3527 19.1888C39.5379 19.0835 39.7216 18.975 39.9083 18.8729C40.3853 18.6108 40.8661 18.3617 41.3499 18.1189C41.4299 18.0783 41.5085 18.0346 41.5888 17.9962C50.4802 13.6058 60.3085 12.4441 69.1269 14.8733C69.3794 14.9431 69.6278 15.0257 69.8798 15.1012C70.1747 15.1906 70.4713 15.2753 70.7626 15.3718C71.1748 15.5101 71.5839 15.6598 71.99 15.8132C72.1149 15.86 72.2426 15.9031 72.3665 15.9511C72.8306 16.1323 73.2896 16.3275 73.7462 16.5308C73.8109 16.5601 73.8764 16.5859 73.94 16.6142C74.4241 16.8333 74.9031 17.0663 75.3791 17.3109C75.4147 17.329 75.449 17.3462 75.4846 17.3644C75.9704 17.6167 76.4508 17.8808 76.9262 18.1589C76.9932 18.198 77.0612 18.2358 77.1273 18.276L77.6687 18.5944C78.7078 19.2384 79.7184 19.9438 80.6943 20.7158C96.6215 33.3134 97.8039 58.4495 83.3299 76.7489C68.856 95.0482 44.1233 99.6867 28.1961 87.0891Z"
          fill="currentColor"
        />
        <path
          d="M74.3982 28.6756C75.1431 29.2647 75.8615 29.905 76.5307 30.5721C76.575 30.6171 76.621 30.6575 76.6677 30.6945C77.2835 31.1815 78.1791 31.1406 78.7464 30.5723C79.3579 29.961 79.358 28.968 78.7466 28.3566C77.9962 27.6052 77.1932 26.8901 76.3205 26.1998C76.3156 26.1959 76.3106 26.1921 76.3057 26.1882L75.3176 27.4047L76.2898 26.1755C75.61 25.6379 74.6519 25.7732 74.1142 26.4529C73.5778 27.1336 73.7185 28.138 74.3982 28.6756Z"
          fill="currentColor"
        />
        <path
          d="M63.1606 23.5053C63.3474 23.6531 63.5732 23.7618 63.8234 23.8118C64.7853 24.0052 65.739 24.252 66.656 24.5477C67.4791 24.8131 68.3621 24.3586 68.6275 23.5355C68.8939 22.7112 68.444 21.8299 67.6153 21.564C66.586 21.2334 65.5171 20.9555 64.4388 20.7399C63.591 20.5689 62.7638 21.1195 62.594 21.9683C62.4752 22.5656 62.7132 23.1515 63.1606 23.5053Z"
          fill="currentColor"
        />
        <path
          d="M81.0559 63.545C80.7534 64.2129 80.9604 64.9819 81.511 65.4175C81.6106 65.4962 81.7198 65.5627 81.8401 65.6178C82.6301 65.973 83.5575 65.6215 83.9129 64.8337C84.3542 63.8539 84.7605 62.8426 85.1183 61.8268C85.4045 61.0102 84.9776 60.1151 84.1598 59.8279C83.3442 59.5404 82.4481 59.9686 82.1596 60.7854C81.8322 61.7173 81.4597 62.6455 81.0559 63.545Z"
          fill="currentColor"
        />
        <path
          d="M87.1222 52.3285C87.2017 51.2504 87.2313 50.157 87.2114 49.0782C87.1929 48.2124 86.4803 47.5269 85.614 47.541C84.7491 47.5583 84.0617 48.2733 84.0768 49.1384C84.0954 50.1202 84.0689 51.1163 83.996 52.0976C83.9552 52.6368 84.1948 53.1321 84.5881 53.4432C84.8254 53.6308 85.1195 53.7516 85.4437 53.7762C86.3077 53.8382 87.059 53.1916 87.1222 52.3285Z"
          fill="currentColor"
        />
        <path
          d="M34.4921 79.1292C33.7288 78.5254 32.9953 77.8714 32.3165 77.1886C31.6814 76.5744 30.7117 76.5727 30.099 77.183C29.4864 77.7934 29.4828 78.7856 30.0922 79.3995C30.8606 80.1711 31.6875 80.9091 32.5479 81.5896L32.6512 81.6713C33.3309 82.2089 34.2642 82.052 34.8009 81.3735C35.3375 80.695 35.1718 79.6668 34.4921 79.1292Z"
          fill="currentColor"
        />
        <path
          d="M56.8196 83.7938C55.8572 84.0077 54.8784 84.1766 53.9072 84.2956C53.0482 84.4014 52.4377 85.1833 52.5448 86.0433C52.5966 86.4679 52.8145 86.834 53.1267 87.081C53.4438 87.3318 53.8572 87.4609 54.2906 87.4081C55.3584 87.2757 56.4367 87.0895 57.4972 86.8553C58.3432 86.6673 58.8758 85.8298 58.6868 84.985C58.4978 84.1401 57.6637 83.6083 56.8196 83.7938Z"
          fill="currentColor"
        />
        <path
          d="M45.1266 84.004C44.1673 83.8147 43.2139 83.5701 42.2937 83.2759C41.4696 83.0117 40.5879 83.4672 40.3249 84.2922C40.1195 84.9309 40.3476 85.6049 40.8454 85.9986C40.9892 86.1124 41.1559 86.2023 41.3425 86.2619C42.3762 86.592 43.447 86.8675 44.5217 87.0801C45.3702 87.2477 46.1949 86.6952 46.3625 85.8467C46.5301 84.9982 45.9795 84.171 45.1266 84.004Z"
          fill="currentColor"
        />
        <path
          d="M85.5671 39.4557C85.2194 38.4174 84.8121 37.3939 84.3548 36.4108C83.9897 35.6245 83.0575 35.2848 82.2734 35.6497C81.4881 36.0136 81.1462 36.946 81.5111 37.7301C81.9193 38.6085 82.2839 39.5243 82.5952 40.4519C82.6948 40.7504 82.8755 40.9993 83.1066 41.1821C83.5073 41.499 84.0562 41.6134 84.5792 41.4397C85.4008 41.1664 85.8426 40.277 85.5671 39.4557Z"
          fill="currentColor"
        />
        <path
          d="M78.5968 70.9431C77.9171 70.4055 76.902 70.5597 76.3644 71.2394C75.7635 71.999 75.1345 72.7363 74.4905 73.4317C73.9019 74.0672 73.9407 75.059 74.5771 75.6463C74.6072 75.674 74.6394 75.7015 74.6701 75.7258C75.3068 76.2294 76.2309 76.165 76.7916 75.5596C77.4901 74.8053 78.1732 74.0049 78.8236 73.1826L78.8858 73.1039C79.4215 72.4266 79.2765 71.4808 78.5968 70.9431Z"
          fill="currentColor"
        />
        <path
          d="M32.5262 36.5654C33.1318 35.7997 33.778 35.0459 34.4448 34.3266C35.0334 33.6911 34.9958 32.7004 34.3613 32.1106C33.7277 31.5375 32.7351 31.5596 32.1475 32.1938C31.4252 32.9732 30.7251 33.7902 30.0689 34.6198L30.0484 34.6456C29.5118 35.3241 29.6364 36.2958 30.3161 36.8334C30.9958 37.3711 31.9895 37.2439 32.5262 36.5654Z"
          fill="currentColor"
        />
        <path
          d="M69.8536 79.6428C69.3821 78.9202 68.4118 78.7122 67.6857 79.1829C66.8561 79.7216 65.9949 80.2293 65.1255 80.6945C64.3619 81.1016 64.0747 82.0533 64.4828 82.8156C64.5871 83.0121 64.729 83.1763 64.8913 83.3046C65.3669 83.6808 66.0368 83.7611 66.6039 83.4583C67.551 82.9506 68.4892 82.396 69.3935 81.8084C70.1197 81.3399 70.3256 80.3698 69.8536 79.6428Z"
          fill="currentColor"
        />
        <path
          d="M44.4681 24.9609C44.061 24.1873 43.1132 23.9052 42.3497 24.3123C41.4043 24.8154 40.4636 25.3681 39.5549 25.9561C38.8289 26.4269 38.6221 27.3982 39.0906 28.1245C39.1859 28.2718 39.3034 28.3987 39.4337 28.5017C39.9462 28.9071 40.68 28.962 41.2578 28.5878C42.0906 28.0477 42.953 27.5409 43.8198 27.0816C44.5834 26.6745 44.8742 25.7257 44.4681 24.9609Z"
          fill="currentColor"
        />
        <path
          d="M24.8994 55.6431C24.9636 54.7788 24.3182 54.0285 23.4536 53.9621C22.5905 53.8988 21.8393 54.5455 21.7738 55.4088C21.6927 56.5016 21.6596 57.5943 21.6778 58.6577C21.6868 59.1464 21.9169 59.5781 22.2733 59.86C22.5474 60.0768 22.8947 60.2036 23.272 60.1964C24.1393 60.1811 24.8258 59.4672 24.813 58.6019C24.7973 57.6364 24.8261 56.6401 24.8994 55.6431Z"
          fill="currentColor"
        />
        <path
          d="M27.8611 44.201C28.2175 43.4119 27.8655 42.4802 27.0801 42.1267C26.292 41.7691 25.3634 42.1196 25.0058 42.9077C24.5623 43.8877 24.156 44.899 23.797 45.9138C23.5671 46.5632 23.7902 47.2612 24.3016 47.6656C24.4331 47.7696 24.5846 47.8535 24.7511 47.9133C25.5667 48.2007 26.4631 47.7748 26.7515 46.9579C27.0792 46.0283 27.4542 45.102 27.8611 44.201Z"
          fill="currentColor"
        />
        <path
          d="M54.6683 20.391C53.6034 20.5197 52.5226 20.7039 51.4587 20.9374C50.6124 21.1232 50.0786 21.9598 50.2654 22.8049C50.3463 23.1725 50.5496 23.4812 50.8225 23.6971C51.179 23.979 51.6545 24.1054 52.1319 23.9994C53.0977 23.7863 54.0768 23.6196 55.0439 23.5033C55.9031 23.3997 56.516 22.6197 56.4112 21.7595C56.3075 20.9003 55.5285 20.2861 54.6683 20.391Z"
          fill="currentColor"
        />
        <path
          d="M27.3493 70.0169C26.943 69.136 26.5803 68.2178 26.2724 67.2909C25.9991 66.4693 25.1109 66.0286 24.2891 66.2997C23.4688 66.5739 23.0246 67.4614 23.2988 68.2817C23.644 69.3181 24.0491 70.3418 24.5047 71.3295C24.611 71.5615 24.7672 71.753 24.954 71.9007C25.4027 72.2556 26.0298 72.352 26.5835 72.0966C27.3691 71.7349 27.7134 70.8044 27.3493 70.0169Z"
          fill="currentColor"
        />
        <path
          d="M61.8817 59.3948C61.1264 57.7984 60.1345 56.1826 58.935 54.5945C58.2431 53.6756 57.7468 53.0173 57.4492 52.618L66.1366 41.6345C66.6072 42.1865 67.0089 42.7699 67.3385 43.3763C68.7133 45.8164 68.9657 47.9502 69.1372 50.5475L67.1131 53.1066C66.5298 53.8441 66.6293 54.696 67.3667 55.2793C68.1042 55.8626 68.9574 55.7642 69.5407 55.0267L75.5381 47.4441C76.1214 46.7067 76.0207 45.8538 75.2845 45.2714C74.5482 44.6891 73.6941 44.7888 73.1118 45.525L71.8334 47.1414C71.7259 46.6987 72.1155 46.5952 71.9401 45.9909C71.2695 43.6583 69.9677 41.3758 68.0645 39.1971L69.4537 37.4407C70.0371 36.7032 69.9376 35.8513 69.2001 35.268C68.4627 34.6846 67.6098 34.7853 67.0274 35.5216L65.7743 37.1059C62.5847 34.669 59.6518 33.5242 57.0509 33.7028C54.3174 33.8924 51.9672 35.2066 50.0656 37.6108C49.0574 38.8854 48.5223 40.3223 48.4754 41.8797C48.4289 43.3935 48.8043 45.0031 49.5927 46.6637C50.3037 48.1672 51.5931 50.2001 53.4307 52.7145L44.1327 64.4699C43.58 63.855 43.1135 63.2322 42.742 62.6107C41.2224 60.058 40.6599 58.776 40.4773 56.3417L42.6579 53.5848C43.2412 52.8473 43.1406 51.9944 42.4043 51.4121C41.6681 50.8297 40.8137 50.9272 40.2304 51.6647L34.233 59.2472C33.6496 59.9847 33.7491 60.8366 34.4866 61.4199C35.224 62.0033 36.0769 61.9026 36.6593 61.1663L37.9387 59.5488C38.7149 62.9301 39.9461 64.5793 42.1929 66.9199L40.827 68.6468C40.2436 69.3843 40.3443 70.2372 41.0806 70.8195C41.8168 71.4018 42.6709 71.3021 43.2533 70.5659L44.5045 68.984C47.7132 71.46 50.803 72.669 53.6935 72.5816C56.7132 72.4924 59.2775 71.1399 61.3123 68.5673C62.3827 67.214 62.948 65.739 62.9968 64.1791C63.0443 62.6641 62.668 61.0558 61.8817 59.3948ZM55.5585 50.0217C55.2349 49.5619 54.8772 49.0592 54.487 48.5168C53.8634 47.6479 53.2486 46.6342 52.6623 45.501C52.1111 44.4397 51.8131 43.3108 51.7766 42.147C51.7401 41.0412 52.0673 40.0692 52.777 39.1719C53.9232 37.7228 55.4344 36.9819 57.4 36.9041C59.2881 36.831 61.4576 37.7158 63.8564 39.5332L55.5585 50.0217ZM53.6478 71.0149C53.6133 71.0156 53.5778 71.0075 53.5443 71.0069C53.8372 71.0029 54.1279 70.989 54.4099 70.9583C54.1614 70.9896 53.908 71.0069 53.6478 71.0149ZM53.447 69.4474C51.3021 69.4613 48.9395 68.4897 46.4248 66.5586L55.3349 55.2936L56.8428 57.3634C57.5614 58.3495 58.2246 59.4234 58.8131 60.5563C59.3643 61.6176 59.6613 62.7477 59.6998 63.9091C59.7343 65.0174 59.4083 65.9903 58.6996 66.8864C57.3483 68.5949 55.6286 69.4326 53.447 69.4474Z"
          fill="currentColor"
        />
      </g>
    </Svg>
  );
}

export function Left(props: Partial<Svg>) {
  return (
    <Svg
      width="18"
      height="39"
      viewBox="0 0 18 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.322 27.7629L12.7305 29.4412L4.06202 20.2943C3.92229 20.1477 3.8114 19.9735 3.73572 19.7815C3.66005 19.5895 3.62109 19.3836 3.62109 19.1757C3.62109 18.9678 3.66005 18.7619 3.73572 18.5699C3.8114 18.3779 3.92229 18.2036 4.06202 18.0571L12.7305 8.90539L14.3205 10.5837L6.18452 19.1733L14.322 27.7629Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconInfo(props: Partial<Svg>) {
  return (
    <Svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 6.93115H8.25V5.43115H9.75M9.75 12.9312H8.25V8.43115H9.75M9 1.68115C8.01509 1.68115 7.03982 1.87515 6.12987 2.25206C5.21993 2.62897 4.39314 3.18141 3.6967 3.87785C2.29018 5.28437 1.5 7.19203 1.5 9.18115C1.5 11.1703 2.29018 13.0779 3.6967 14.4845C4.39314 15.1809 5.21993 15.7333 6.12987 16.1102C7.03982 16.4872 8.01509 16.6812 9 16.6812C10.9891 16.6812 12.8968 15.891 14.3033 14.4845C15.7098 13.0779 16.5 11.1703 16.5 9.18115C16.5 8.19624 16.306 7.22097 15.9291 6.31103C15.5522 5.40108 14.9997 4.57429 14.3033 3.87785C13.6069 3.18141 12.7801 2.62897 11.8701 2.25206C10.9602 1.87515 9.98491 1.68115 9 1.68115Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconSortMenu(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 18.5989V16.5989H9.5V18.5989H3.5ZM3.5 13.5989V11.5989H15.5V13.5989H3.5ZM3.5 8.59888V6.59888H21.5V8.59888H3.5Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconCheck(props: Partial<Svg>) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9907 1.22164C30.36 0.999489 30.801 0.929031 31.2212 1.02505C31.6413 1.12108 32.0079 1.37612 32.244 1.73664L33.894 4.25331C34.1091 4.58208 34.2012 4.97626 34.1539 5.36629C34.1066 5.75631 33.9231 6.1171 33.6357 6.38497L33.6307 6.39164L33.6074 6.41331L33.5124 6.50164L33.1374 6.85997C31.0625 8.87274 29.0504 10.9493 27.104 13.0866C23.4424 17.1133 19.094 22.3833 16.1674 27.4966C15.3507 28.9233 13.3557 29.23 12.1724 27.9983L1.36404 16.7683C1.20915 16.6073 1.08821 16.4168 1.0084 16.2081C0.928597 15.9995 0.891558 15.7769 0.899488 15.5536C0.907417 15.3304 0.960153 15.111 1.05456 14.9085C1.14897 14.706 1.28312 14.5246 1.44904 14.375L4.71571 11.4283C5.00278 11.1695 5.37088 11.0185 5.757 11.0012C6.14313 10.9838 6.52327 11.1012 6.83238 11.3333L12.3474 15.4683C20.9624 6.97331 25.8474 3.71331 29.9907 1.22164Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function Facebook(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9502 12.1989C22.9502 6.52235 18.3431 1.91525 12.6665 1.91525C6.98991 1.91525 2.38281 6.52235 2.38281 12.1989C2.38281 17.1762 5.9204 21.3206 10.6098 22.277V15.2841H8.55303V12.1989H10.6098V9.62802C10.6098 7.64327 12.2243 6.02873 14.2091 6.02873H16.78V9.11384H14.7232C14.1576 9.11384 13.6949 9.5766 13.6949 10.1422V12.1989H16.78V15.2841H13.6949V22.4312C18.8881 21.917 22.9502 17.5362 22.9502 12.1989Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Instagram(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.667 8.94824C11.805 8.94824 10.9784 9.29065 10.3689 9.90015C9.7594 10.5096 9.41699 11.3363 9.41699 12.1982C9.41699 13.0602 9.7594 13.8868 10.3689 14.4963C10.9784 15.1058 11.805 15.4482 12.667 15.4482C13.5289 15.4482 14.3556 15.1058 14.9651 14.4963C15.5746 13.8868 15.917 13.0602 15.917 12.1982C15.917 11.3363 15.5746 10.5096 14.9651 9.90015C14.3556 9.29065 13.5289 8.94824 12.667 8.94824Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89509 2.35595C10.7314 1.93097 14.6029 1.93097 18.4391 2.35595C20.5349 2.58992 22.2246 4.23986 22.4707 6.34339C22.9254 10.2334 22.9254 14.163 22.4707 18.053C22.2246 20.1565 20.5349 21.8065 18.4402 22.0415C14.6036 22.4666 10.7317 22.4666 6.89509 22.0415C4.79928 21.8065 3.10961 20.1565 2.8635 18.0541C2.40878 14.1638 2.40878 10.2337 2.8635 6.34339C3.10961 4.23986 4.79928 2.58992 6.89509 2.35595ZM18.1853 5.57637C17.8926 5.57637 17.6119 5.69264 17.4049 5.89961C17.1979 6.10659 17.0817 6.3873 17.0817 6.68C17.0817 6.97271 17.1979 7.25342 17.4049 7.46039C17.6119 7.66737 17.8926 7.78364 18.1853 7.78364C18.478 7.78364 18.7587 7.66737 18.9657 7.46039C19.1727 7.25342 19.2889 6.97271 19.2889 6.68C19.2889 6.3873 19.1727 6.10659 18.9657 5.89961C18.7587 5.69264 18.478 5.57637 18.1853 5.57637ZM7.42483 12.1982C7.42483 10.8079 7.97715 9.47446 8.96026 8.49134C9.94338 7.50822 11.2768 6.95591 12.6671 6.95591C14.0575 6.95591 15.3908 7.50822 16.374 8.49134C17.3571 9.47446 17.9094 10.8079 17.9094 12.1982C17.9094 13.5885 17.3571 14.9219 16.374 15.905C15.3908 16.8882 14.0575 17.4405 12.6671 17.4405C11.2768 17.4405 9.94338 16.8882 8.96026 15.905C7.97715 14.9219 7.42483 13.5885 7.42483 12.1982Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Linkedin(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.97 2.44824H7.36399C6.18457 2.44824 5.05346 2.91676 4.21949 3.75074C3.38551 4.58471 2.91699 5.71582 2.91699 6.89524V17.5012C2.91699 18.6807 3.38551 19.8118 4.21949 20.6457C5.05346 21.4797 6.18457 21.9482 7.36399 21.9482H17.97C19.1494 21.9482 20.2805 21.4797 21.1145 20.6457C21.9485 19.8118 22.417 18.6807 22.417 17.5012V6.89524C22.417 5.71582 21.9485 4.58471 21.1145 3.75074C20.2805 2.91676 19.1494 2.44824 17.97 2.44824ZM9.50999 18.1902C9.51313 18.2447 9.5051 18.2992 9.48641 18.3504C9.46771 18.4016 9.43875 18.4485 9.40129 18.4881C9.36383 18.5277 9.31866 18.5592 9.26857 18.5808C9.21848 18.6023 9.16451 18.6133 9.10999 18.6132H7.32999C7.22265 18.6106 7.12062 18.566 7.04582 18.489C6.97102 18.4119 6.92944 18.3086 6.92999 18.2012V10.7982C6.92852 10.7448 6.93778 10.6916 6.95722 10.6418C6.97667 10.592 7.0059 10.5466 7.04319 10.5083C7.08048 10.4699 7.12507 10.4395 7.17433 10.4187C7.2236 10.3979 7.27653 10.3872 7.32999 10.3872H9.10999C9.16346 10.3872 9.21639 10.3979 9.26565 10.4187C9.31491 10.4395 9.35951 10.4699 9.3968 10.5083C9.43409 10.5466 9.46332 10.592 9.48276 10.6418C9.5022 10.6916 9.51146 10.7448 9.50999 10.7982V18.1902ZM8.18699 8.83024C7.99428 8.8288 7.80373 8.78941 7.62624 8.71433C7.44875 8.63924 7.28778 8.52993 7.15253 8.39264C7.01729 8.25535 6.9104 8.09277 6.83799 7.91417C6.76558 7.73557 6.72905 7.54446 6.73049 7.35174C6.73194 7.15903 6.77133 6.96848 6.84641 6.79099C6.92149 6.6135 7.0308 6.45253 7.16809 6.31728C7.30538 6.18204 7.46797 6.07515 7.64657 6.00274C7.82516 5.93033 8.01628 5.8938 8.20899 5.89524C8.59151 5.90768 8.95402 6.06912 9.21918 6.3451C9.48433 6.62108 9.63114 6.98976 9.62827 7.37247C9.6254 7.75518 9.47308 8.12161 9.20381 8.39359C8.93455 8.66556 8.56965 8.82154 8.18699 8.82824M19.004 18.1782C19.0035 18.2793 18.9639 18.3762 18.8933 18.4486C18.8228 18.5209 18.727 18.5631 18.626 18.5662H16.747C16.6458 18.5631 16.5498 18.5208 16.4793 18.4482C16.4088 18.3756 16.3692 18.2785 16.369 18.1772V14.7532C16.369 14.2422 16.525 12.5302 15.013 12.5302C13.834 12.5302 13.601 13.7302 13.556 14.2642V18.2552C13.556 18.3566 13.5166 18.4541 13.446 18.5269C13.3755 18.5997 13.2793 18.6421 13.178 18.6452H11.355C11.2517 18.645 11.1528 18.6038 11.0799 18.5307C11.0069 18.4576 10.966 18.3585 10.966 18.2552V10.7622C10.9691 10.6609 11.0116 10.5648 11.0844 10.4942C11.1572 10.4236 11.2546 10.3842 11.356 10.3842H13.178C13.2794 10.3842 13.3768 10.4236 13.4496 10.4942C13.5224 10.5648 13.5649 10.6609 13.568 10.7622V11.4072C13.834 11.0179 14.2013 10.7085 14.6303 10.5125C15.0592 10.3166 15.5335 10.2414 16.002 10.2952C19.037 10.2952 19.026 13.1302 19.026 14.7422L19.004 18.1782Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function Twitter(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.68446 2.42325C4.14402 2.42325 2.8916 3.67567 2.8916 5.2161V19.1804C2.8916 20.7208 4.14402 21.9732 5.68446 21.9732H19.6487C21.1892 21.9732 22.4416 20.7208 22.4416 19.1804V5.2161C22.4416 3.67567 21.1892 2.42325 19.6487 2.42325H5.68446ZM18.6494 6.08887L14.1198 11.2644L19.448 18.3076H15.2762L12.012 14.0354L8.27221 18.3076H6.19939L11.0432 12.7699L5.9332 6.08887H10.2098L13.1641 9.9945L16.5766 6.08887H18.6494ZM16.9999 17.0683L9.58573 7.26274H8.35076L15.8478 17.0683H16.9955H16.9999Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconComment(props: Partial<Svg>) {
  return (
    <Svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8104 19.1999H10.8105C11.7961 19.2002 12.7721 19.0064 13.6828 18.6294C14.5935 18.2524 15.4209 17.6996 16.1179 17.0028C16.8148 16.3059 17.3677 15.4785 17.7448 14.5679C18.1219 13.6573 18.3158 12.6813 18.3156 11.6957V11.6956C18.3156 8.01353 15.3311 5.02905 11.6491 5.02905H11.3539C6.41094 5.02905 3.0445 10.038 4.90902 14.6163L5.76409 16.7132C5.76412 16.7133 5.76415 16.7134 5.76418 16.7134C5.8422 16.9046 5.85637 17.1159 5.80458 17.3158C5.75277 17.5158 5.63772 17.6937 5.47659 17.823M10.8104 19.1999L5.47659 17.823M10.8104 19.1999H3.76044L5.47659 17.823M10.8104 19.1999L5.47659 17.823"
        fill="white"
        stroke="white"
      />
    </Svg>
  );
}

export function IconCopy(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6922 3.70617C16.9908 3.66899 16.2064 3.66899 15.3648 3.669L15.335 3.669H12.265L12.235 3.669C10.9821 3.66899 9.85474 3.66899 8.94155 3.79144L8.94082 3.79153C7.94174 3.927 6.91325 4.2402 6.07073 5.08617C5.22856 5.93178 4.91676 6.96288 4.78243 7.96561L4.7824 7.96584C4.65999 8.88288 4.65999 10.0151 4.66 11.2722L4.66 11.302V16.312V16.3259C4.66 17.0581 4.66 17.9046 4.683 18.6645C3.96256 18.0942 3.5 17.2099 3.5 16.217V10.379C3.5 8.59476 3.50103 7.23065 3.64258 6.17335L3.64259 6.17323C3.78624 5.09825 4.07936 4.30645 4.69004 3.69406L4.69029 3.69382C5.29985 3.08171 6.08742 2.78801 7.15789 2.64351L7.15809 2.64348C8.20994 2.50105 9.56859 2.5 11.346 2.5H15.2399L17.6922 3.70617ZM17.6922 3.70617C17.4943 3.44971 17.2564 3.22442 16.9858 3.03973C16.4713 2.68849 15.863 2.50041 15.24 2.5L17.6922 3.70617Z"
        fill="white"
        stroke="white"
      />
      <path
        d="M6.6001 11.397C6.6001 8.67101 6.6001 7.30801 7.4441 6.46101C8.2871 5.61401 9.6441 5.61401 12.3601 5.61401H15.2401C17.9551 5.61401 19.3131 5.61401 20.1571 6.46101C21.0011 7.30801 21.0001 8.67101 21.0001 11.397V16.217C21.0001 18.943 21.0001 20.306 20.1571 21.153C19.3131 22 17.9551 22 15.2401 22H12.3601C9.6451 22 8.2871 22 7.4441 21.153C6.6001 20.306 6.6001 18.943 6.6001 16.217V11.397Z"
        fill="white"
      />
    </Svg>
  );
}

export function IconShareFacebook(props: Partial<Svg>) {
  return (
    <Svg
      width="55"
      height="54"
      viewBox="0 0 55 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="54" height="54" rx="27" fill="white" />
      <path
        d="M41.6668 27C41.6668 19.18 35.3202 12.8333 27.5002 12.8333C19.6802 12.8333 13.3335 19.18 13.3335 27C13.3335 33.8566 18.2068 39.5658 24.6668 40.8833V31.25H21.8335V27H24.6668V23.4583C24.6668 20.7241 26.891 18.5 29.6252 18.5H33.1668V22.75H30.3335C29.5543 22.75 28.9168 23.3875 28.9168 24.1666V27H33.1668V31.25H28.9168V41.0958C36.071 40.3875 41.6668 34.3525 41.6668 27Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconShareMessenger(props: Partial<Svg>) {
  return (
    <Svg
      width="55"
      height="54"
      viewBox="0 0 55 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="54" height="54" rx="27" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5002 12.8333C35.3244 12.8333 41.6668 19.1757 41.6668 27C41.6668 34.8242 35.3244 41.1666 27.5002 41.1666C25.089 41.1701 22.7171 40.5555 20.6109 39.3816L20.1788 39.1295L15.8835 40.3931C15.6498 40.462 15.4023 40.4701 15.1646 40.4165C14.9268 40.3629 14.7067 40.2496 14.5251 40.0871C14.3435 39.9246 14.2064 39.7185 14.1268 39.4881C14.0471 39.2578 14.0277 39.011 14.0702 38.7711L14.107 38.6166L15.3707 34.3213C14.0348 32.1131 13.3302 29.5808 13.3335 27C13.3335 19.1757 19.6759 12.8333 27.5002 12.8333ZM24.3736 23.8734L20.1236 28.1234C19.9883 28.2541 19.8804 28.4104 19.8061 28.5832C19.7319 28.7561 19.6928 28.942 19.6912 29.1301C19.6895 29.3182 19.7254 29.5047 19.7966 29.6788C19.8678 29.8529 19.973 30.0111 20.106 30.1441C20.239 30.2771 20.3972 30.3823 20.5713 30.4536C20.7454 30.5248 20.932 30.5606 21.1201 30.559C21.3082 30.5574 21.4941 30.5183 21.6669 30.444C21.8398 30.3698 21.9961 30.2619 22.1268 30.1266L25.3752 26.8781L28.6236 30.1266C28.8893 30.3921 29.2495 30.5413 29.6252 30.5413C30.0008 30.5413 30.3611 30.3921 30.6268 30.1266L34.8768 25.8766C35.1348 25.6094 35.2776 25.2515 35.2744 24.8801C35.2712 24.5086 35.1222 24.1533 34.8595 23.8907C34.5968 23.628 34.2415 23.479 33.8701 23.4758C33.4986 23.4725 33.1408 23.6153 32.8736 23.8734L29.6252 27.1218L26.3768 23.8734C26.1111 23.6078 25.7508 23.4586 25.3752 23.4586C24.9995 23.4586 24.6393 23.6078 24.3736 23.8734Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconShareWhatsapp(props: Partial<Svg>) {
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="white" />
      <path
        d="M27.0016 12.8333C34.8259 12.8333 41.1683 19.1757 41.1683 27C41.1683 34.8242 34.8259 41.1666 27.0016 41.1666C24.498 41.171 22.0385 40.5084 19.8758 39.2471L12.8406 41.1666L14.756 34.1286C13.4937 31.9653 12.8306 29.5047 12.835 27C12.835 19.1757 19.1774 12.8333 27.0016 12.8333ZM22.1736 20.3416L21.8903 20.353C21.7071 20.3656 21.5281 20.4137 21.3633 20.4946C21.2097 20.5818 21.0694 20.6906 20.9468 20.8176C20.7768 20.9777 20.6805 21.1166 20.5771 21.2511C20.0531 21.9324 19.7709 22.7688 19.7752 23.6283C19.7781 24.3225 19.9594 24.9982 20.2427 25.6301C20.8221 26.9079 21.7756 28.2608 23.0336 29.5146C23.3367 29.8163 23.6342 30.1195 23.9544 30.4014C25.5176 31.7775 27.3803 32.77 29.3944 33.2999L30.1991 33.4231C30.4611 33.4373 30.7232 33.4175 30.9867 33.4047C31.3992 33.383 31.802 33.2713 32.1668 33.0775C32.3522 32.9816 32.5332 32.8776 32.7094 32.7658C32.7094 32.7658 32.7694 32.7252 32.8865 32.6383C33.0777 32.4966 33.1953 32.3961 33.354 32.2303C33.473 32.1075 33.5721 31.9649 33.6515 31.8025C33.762 31.5716 33.8725 31.131 33.9178 30.7641C33.9518 30.4836 33.9419 30.3306 33.9376 30.2356C33.932 30.0841 33.8059 29.9268 33.6685 29.8602L32.844 29.4905C32.844 29.4905 31.6115 28.9536 30.8578 28.6107C30.7789 28.5764 30.6944 28.5567 30.6085 28.5526C30.5115 28.5425 30.4136 28.5533 30.3212 28.5844C30.2288 28.6154 30.1441 28.6659 30.073 28.7326C30.0659 28.7297 29.971 28.8105 28.9467 30.0515C28.8879 30.1305 28.807 30.1902 28.7141 30.223C28.6213 30.2558 28.5208 30.2602 28.4254 30.2356C28.3331 30.211 28.2426 30.1798 28.1548 30.1421C27.9791 30.0685 27.9182 30.0401 27.7978 29.9891C26.9845 29.6348 26.2316 29.1554 25.5666 28.5682C25.3881 28.4124 25.2223 28.2424 25.0523 28.0781C24.495 27.5443 24.0093 26.9405 23.6073 26.2817L23.5237 26.1471C23.4646 26.0562 23.4161 25.9587 23.3792 25.8567C23.3254 25.6485 23.4656 25.4813 23.4656 25.4813C23.4656 25.4813 23.8099 25.1045 23.97 24.9005C24.1258 24.7021 24.2576 24.5095 24.3426 24.3721C24.5097 24.1029 24.5622 23.8266 24.4743 23.6127C24.0777 22.6437 23.6678 21.6799 23.2446 20.7213C23.1611 20.5315 22.9131 20.3955 22.6879 20.3686C22.6114 20.3591 22.5349 20.3516 22.4584 20.3459C22.2682 20.335 22.0774 20.3369 21.8875 20.3516L22.1736 20.3416Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconShareEmail(props: Partial<Svg>) {
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="white" />
      <path
        d="M38.3335 21.3334L27.0002 28.4167L15.6668 21.3334V18.5L27.0002 25.5834L38.3335 18.5M38.3335 15.6667H15.6668C14.0943 15.6667 12.8335 16.9275 12.8335 18.5V35.5C12.8335 36.2515 13.132 36.9721 13.6634 37.5035C14.1947 38.0348 14.9154 38.3334 15.6668 38.3334H38.3335C39.0849 38.3334 39.8056 38.0348 40.337 37.5035C40.8683 36.9721 41.1668 36.2515 41.1668 35.5V18.5C41.1668 17.7486 40.8683 17.0279 40.337 16.4966C39.8056 15.9652 39.0849 15.6667 38.3335 15.6667Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconShareX(props: Partial<Svg>) {
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="white" />
      <g clipPath="url(#clip0_2483_14588)">
        <mask
          id="mask0_2483_14588"
          maskUnits="userSpaceOnUse"
          x="10"
          y="10"
          width="34"
          height="34"
        >
          <path d="M10 10H44V44H10V10Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2483_14588)">
          <path
            d="M36.775 11.5931H41.9891L30.5991 24.6443L44 42.4069H33.5086L25.2854 31.6361L15.8869 42.4069H10.6679L22.8496 28.4426L10 11.5956H20.7586L28.1803 21.4386L36.775 11.5931ZM34.9414 39.2789H37.8314L19.18 14.5584H16.0811L34.9414 39.2789Z"
            fill="#282C35"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2483_14588">
          <rect
            width="34"
            height="34"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </Svg>
  );
}

export function IconShareReddit(props: Partial<Svg>) {
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="white" />
      <path
        d="M25.2294 28.4733C25.2294 27.6658 24.5635 27 23.756 27C22.9485 27 22.2827 27.6658 22.2827 28.4733C22.2827 28.8641 22.4379 29.2388 22.7142 29.5151C22.9905 29.7914 23.3653 29.9467 23.756 29.9467C24.1468 29.9467 24.5215 29.7914 24.7979 29.5151C25.0742 29.2388 25.2294 28.8641 25.2294 28.4733ZM29.961 31.8308C29.3235 32.4683 27.9635 32.695 27.0002 32.695C26.0369 32.695 24.6769 32.4683 24.0394 31.8308C24.0049 31.7939 23.9632 31.7645 23.9169 31.7444C23.8706 31.7243 23.8207 31.7139 23.7702 31.7139C23.7197 31.7139 23.6698 31.7243 23.6235 31.7444C23.5772 31.7645 23.5355 31.7939 23.501 31.8308C23.4642 31.8653 23.4347 31.907 23.4146 31.9533C23.3945 31.9996 23.3841 32.0495 23.3841 32.1C23.3841 32.1505 23.3945 32.2004 23.4146 32.2467C23.4347 32.293 23.4642 32.3347 23.501 32.3692C24.5069 33.375 26.4335 33.46 27.0002 33.46C27.5669 33.46 29.4935 33.375 30.4994 32.3692C30.5363 32.3347 30.5657 32.293 30.5858 32.2467C30.6059 32.2004 30.6163 32.1505 30.6163 32.1C30.6163 32.0495 30.6059 31.9996 30.5858 31.9533C30.5657 31.907 30.5363 31.8653 30.4994 31.8308C30.3577 31.6892 30.1169 31.6892 29.961 31.8308ZM30.2444 27C29.4369 27 28.771 27.6658 28.771 28.4733C28.771 29.2808 29.4369 29.9467 30.2444 29.9467C31.0519 29.9467 31.7177 29.2808 31.7177 28.4733C31.7177 27.6658 31.066 27 30.2444 27Z"
        fill="#282C35"
      />
      <path
        d="M27.0002 12.8333C19.1802 12.8333 12.8335 19.18 12.8335 27C12.8335 34.82 19.1802 41.1666 27.0002 41.1666C34.8202 41.1666 41.1668 34.82 41.1668 27C41.1668 19.18 34.8202 12.8333 27.0002 12.8333ZM35.2168 28.8841C35.2452 29.0825 35.2593 29.295 35.2593 29.5075C35.2593 32.6808 31.5618 35.2591 27.0002 35.2591C22.4385 35.2591 18.741 32.6808 18.741 29.5075C18.741 29.295 18.7552 29.0825 18.7835 28.8841C18.061 28.5583 17.5652 27.8358 17.5652 27C17.5631 26.5937 17.681 26.1959 17.9043 25.8565C18.1276 25.5171 18.4461 25.2513 18.82 25.0924C19.1938 24.9334 19.6063 24.8885 20.0056 24.9633C20.4049 25.038 20.7733 25.2291 21.0643 25.5125C22.4952 24.4783 24.4785 23.8266 26.6743 23.7558L27.7227 18.8116C27.7368 18.7125 27.7935 18.6275 27.8785 18.585C27.9635 18.5283 28.0627 18.5141 28.1618 18.5283L31.5902 19.265C31.7064 19.0292 31.8837 18.8289 32.1035 18.6847C32.3233 18.5405 32.5777 18.4578 32.8402 18.445C33.1028 18.4323 33.364 18.4901 33.5967 18.6123C33.8294 18.7346 34.0252 18.9169 34.1637 19.1403C34.3022 19.3637 34.3785 19.6201 34.3845 19.8829C34.3905 20.1457 34.3261 20.4054 34.1979 20.6349C34.0698 20.8644 33.8826 21.0555 33.6557 21.1882C33.4288 21.321 33.1705 21.3907 32.9077 21.39C32.1143 21.39 31.4768 20.7666 31.4343 19.9875L28.3602 19.3358L27.4252 23.7558C29.5927 23.8266 31.5335 24.4925 32.9502 25.5125C33.1673 25.3051 33.4272 25.1477 33.7116 25.0512C33.9959 24.9548 34.2979 24.9216 34.5965 24.954C34.895 24.9865 35.1828 25.0838 35.4398 25.2391C35.6968 25.3944 35.9168 25.604 36.0843 25.8532C36.2519 26.1024 36.3629 26.3852 36.4097 26.6818C36.4566 26.9785 36.438 27.2817 36.3554 27.5704C36.2727 27.8591 36.128 28.1263 35.9314 28.3532C35.7347 28.5801 35.4908 28.7613 35.2168 28.8841Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconShareInstagram(props: Partial<Svg>) {
  return (
    <Svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="54" height="54" rx="27" fill="white" />
      <path
        d="M27.0002 22.3958C25.7791 22.3958 24.608 22.8809 23.7445 23.7443C22.8811 24.6078 22.396 25.7789 22.396 27C22.396 28.2211 22.8811 29.3922 23.7445 30.2556C24.608 31.1191 25.7791 31.6041 27.0002 31.6041C28.2213 31.6041 29.3924 31.1191 30.2558 30.2556C31.1192 29.3922 31.6043 28.2211 31.6043 27C31.6043 25.7789 31.1192 24.6078 30.2558 23.7443C29.3924 22.8809 28.2213 22.3958 27.0002 22.3958Z"
        fill="#282C35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.823 13.0568C24.2577 12.4547 29.7423 12.4547 35.177 13.0568C38.1461 13.3882 40.5398 15.7256 40.8885 18.7056C41.5325 24.2164 41.5325 29.7835 40.8885 35.2942C40.5398 38.2742 38.1461 40.6117 35.1786 40.9447C29.7434 41.5468 24.2582 41.5468 18.823 40.9447C15.8539 40.6117 13.4602 38.2742 13.1116 35.2958C12.4674 29.7845 12.4674 24.2169 13.1116 18.7056C13.4602 15.7256 15.8539 13.3882 18.823 13.0568ZM34.8174 17.619C34.4028 17.619 34.0051 17.7837 33.7119 18.077C33.4187 18.3702 33.254 18.7678 33.254 19.1825C33.254 19.5972 33.4187 19.9948 33.7119 20.2881C34.0051 20.5813 34.4028 20.746 34.8174 20.746C35.2321 20.746 35.6298 20.5813 35.923 20.2881C36.2162 19.9948 36.3809 19.5972 36.3809 19.1825C36.3809 18.7678 36.2162 18.3702 35.923 18.077C35.6298 17.7837 35.2321 17.619 34.8174 17.619ZM19.5734 26.9999C19.5734 25.0303 20.3559 23.1413 21.7486 21.7486C23.1414 20.3558 25.0304 19.5734 27 19.5734C28.9697 19.5734 30.8586 20.3558 32.2514 21.7486C33.6441 23.1413 34.4266 25.0303 34.4266 26.9999C34.4266 28.9696 33.6441 30.8586 32.2514 32.2513C30.8586 33.6441 28.9697 34.4265 27 34.4265C25.0304 34.4265 23.1414 33.6441 21.7486 32.2513C20.3559 30.8586 19.5734 28.9696 19.5734 26.9999Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconAttach(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3137 3.30215C11.7759 2.82822 12.3275 2.45078 12.9366 2.19171C13.5458 1.93263 14.2003 1.79709 14.8622 1.79294C15.5241 1.7888 16.1803 1.91613 16.7926 2.16754C17.405 2.41896 17.9613 2.78947 18.4293 3.25756C18.8974 3.72566 19.2678 4.28203 19.5191 4.8944C19.7704 5.50677 19.8977 6.16295 19.8934 6.82488C19.8892 7.48681 19.7536 8.14131 19.4944 8.75041C19.2352 9.35951 18.8577 9.91109 18.3837 10.3731L10.6067 18.1511C10.329 18.4335 9.99817 18.658 9.63324 18.8119C9.26832 18.9657 8.87655 19.0457 8.48053 19.0474C8.08451 19.0491 7.69208 18.9723 7.32588 18.8215C6.95968 18.6708 6.62695 18.449 6.34689 18.169C6.06683 17.889 5.84497 17.5563 5.69413 17.1902C5.54328 16.824 5.46642 16.4316 5.46798 16.0356C5.46955 15.6395 5.54951 15.2478 5.70325 14.8828C5.85699 14.5178 6.08146 14.1869 6.36373 13.9091L14.1417 6.13115L15.5557 7.54515L7.77773 15.3231C7.68222 15.4154 7.60604 15.5257 7.55363 15.6477C7.50122 15.7697 7.47364 15.901 7.47248 16.0337C7.47133 16.1665 7.49663 16.2982 7.54691 16.4211C7.59719 16.544 7.67144 16.6557 7.76534 16.7495C7.85923 16.8434 7.97088 16.9177 8.09378 16.968C8.21667 17.0182 8.34835 17.0436 8.48113 17.0424C8.61391 17.0412 8.74513 17.0137 8.86714 16.9612C8.98914 16.9088 9.09949 16.8327 9.19173 16.7371L16.9707 8.95915C17.2493 8.68055 17.4703 8.3498 17.6211 7.98579C17.7719 7.62179 17.8495 7.23165 17.8495 6.83765C17.8495 6.44365 17.7719 6.05351 17.6211 5.6895C17.4703 5.32549 17.2493 4.99475 16.9707 4.71615C16.6921 4.43755 16.3614 4.21655 15.9974 4.06577C15.6334 3.915 15.2432 3.83739 14.8492 3.83739C14.4552 3.83739 14.0651 3.915 13.7011 4.06577C13.3371 4.21655 13.0063 4.43755 12.7277 4.71615L4.94973 12.4951C4.03894 13.4382 3.53497 14.7012 3.54636 16.0122C3.55775 17.3231 4.0836 18.5772 5.01064 19.5042C5.93768 20.4313 7.19174 20.9571 8.50273 20.9685C9.81371 20.9799 11.0767 20.4759 12.0197 19.5651L20.5057 11.0801L21.9197 12.4951L13.4347 20.9801C12.1219 22.293 10.3413 23.0305 8.48473 23.0305C6.62812 23.0305 4.84755 22.293 3.53473 20.9801C2.22191 19.6673 1.48438 17.8868 1.48438 16.0301C1.48437 14.1735 2.22191 12.393 3.53473 11.0801L11.3137 3.30215Z"
        fill="currentColor"
        fillOpacity="0.4"
      />
    </Svg>
  );
}

export function IconEmogie(props: Partial<Svg>) {
  return (
    <Svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 21.1812C16.5228 21.1812 21 16.704 21 11.1812C21 5.6583 16.5228 1.18115 11 1.18115C5.47715 1.18115 1 5.6583 1 11.1812C1 16.704 5.47715 21.1812 11 21.1812Z"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14.1812C7.46574 14.8021 8.06966 15.3061 8.76393 15.6533C9.45821 16.0004 10.2238 16.1812 11 16.1812C11.7762 16.1812 12.5418 16.0004 13.2361 15.6533C13.9303 15.3061 14.5343 14.8021 15 14.1812M7.009 8.18115H7M15 8.18115H14.991"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconCommentMenu(props: Partial<Svg>) {
  return (
    <Svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 15.4312C9 15.0996 9.1317 14.7817 9.36612 14.5473C9.60054 14.3128 9.91848 14.1812 10.25 14.1812C10.5815 14.1812 10.8995 14.3128 11.1339 14.5473C11.3683 14.7817 11.5 15.0996 11.5 15.4312C11.5 15.7627 11.3683 16.0806 11.1339 16.315C10.8995 16.5495 10.5815 16.6812 10.25 16.6812C9.91848 16.6812 9.60054 16.5495 9.36612 16.315C9.1317 16.0806 9 15.7627 9 15.4312ZM9 10.4312C9 10.0996 9.1317 9.78169 9.36612 9.54727C9.60054 9.31285 9.91848 9.18115 10.25 9.18115C10.5815 9.18115 10.8995 9.31285 11.1339 9.54727C11.3683 9.78169 11.5 10.0996 11.5 10.4312C11.5 10.7627 11.3683 11.0806 11.1339 11.315C10.8995 11.5495 10.5815 11.6812 10.25 11.6812C9.91848 11.6812 9.60054 11.5495 9.36612 11.315C9.1317 11.0806 9 10.7627 9 10.4312ZM9 5.43115C9 5.09963 9.1317 4.78169 9.36612 4.54727C9.60054 4.31285 9.91848 4.18115 10.25 4.18115C10.5815 4.18115 10.8995 4.31285 11.1339 4.54727C11.3683 4.78169 11.5 5.09963 11.5 5.43115C11.5 5.76267 11.3683 6.08062 11.1339 6.31504C10.8995 6.54946 10.5815 6.68115 10.25 6.68115C9.91848 6.68115 9.60054 6.54946 9.36612 6.31504C9.1317 6.08062 9 5.76267 9 5.43115Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconLike(props: Partial<Svg>) {
  return (
    <Svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 10.7631C2 10.5661 2.0388 10.371 2.11418 10.189C2.18956 10.007 2.30005 9.84169 2.43934 9.7024C2.57863 9.56311 2.74399 9.45262 2.92597 9.37724C3.10796 9.30186 3.30302 9.26306 3.5 9.26306C3.69698 9.26306 3.89204 9.30186 4.07403 9.37724C4.25601 9.45262 4.42137 9.56311 4.56066 9.7024C4.69995 9.84169 4.81044 10.007 4.88582 10.189C4.9612 10.371 5 10.5661 5 10.7631V16.7631C5 17.1609 4.84196 17.5424 4.56066 17.8237C4.27936 18.105 3.89782 18.2631 3.5 18.2631C3.10218 18.2631 2.72064 18.105 2.43934 17.8237C2.15804 17.5424 2 17.1609 2 16.7631V10.7631ZM6 10.5961V16.0261C5.99983 16.3977 6.10322 16.7621 6.29858 17.0783C6.49394 17.3944 6.77353 17.6499 7.106 17.8161L7.156 17.8411C7.71089 18.1184 8.32267 18.2629 8.943 18.2631H14.359C14.8215 18.2632 15.2698 18.1031 15.6276 17.8099C15.9853 17.5167 16.2303 17.1086 16.321 16.6551L17.521 10.6551C17.579 10.3649 17.5719 10.0656 17.5002 9.7785C17.4285 9.49145 17.294 9.22388 17.1065 8.99507C16.9189 8.76627 16.6829 8.58193 16.4155 8.45535C16.148 8.32877 15.8559 8.26309 15.56 8.26306H12V4.26306C12 3.73263 11.7893 3.22392 11.4142 2.84885C11.0391 2.47378 10.5304 2.26306 10 2.26306C9.73478 2.26306 9.48043 2.36842 9.29289 2.55595C9.10536 2.74349 9 2.99785 9 3.26306V3.93006C9 4.79554 8.71929 5.63768 8.2 6.33006L6.8 8.19606C6.28071 8.88845 6 9.73058 6 10.5961Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconDislike(props: Partial<Svg>) {
  return (
    <Svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5605 9.76306C17.5605 9.96004 17.5217 10.1551 17.4464 10.3371C17.371 10.5191 17.2605 10.6844 17.1212 10.8237C16.9819 10.963 16.8166 11.0735 16.6346 11.1489C16.4526 11.2243 16.2575 11.2631 16.0605 11.2631C15.8636 11.2631 15.6685 11.2243 15.4865 11.1489C15.3045 11.0735 15.1392 10.963 14.9999 10.8237C14.8606 10.6844 14.7501 10.5191 14.6747 10.3371C14.5993 10.1551 14.5605 9.96004 14.5605 9.76306V3.76306C14.5605 3.36524 14.7186 2.98371 14.9999 2.7024C15.2812 2.4211 15.6627 2.26306 16.0605 2.26306C16.4584 2.26306 16.8399 2.4211 17.1212 2.7024C17.4025 2.98371 17.5605 3.36524 17.5605 3.76306V9.76306ZM13.5605 9.93006V4.50006C13.5607 4.1284 13.4573 3.76404 13.262 3.44786C13.0666 3.13168 12.787 2.8762 12.4545 2.71006L12.4045 2.68506C11.8497 2.40773 11.2379 2.26326 10.6175 2.26306H5.20155C4.73902 2.26288 4.29072 2.42301 3.93299 2.7162C3.57526 3.00939 3.3302 3.4175 3.23955 3.87106L2.03955 9.87106C1.98156 10.1612 1.98866 10.4606 2.06034 10.7476C2.13203 11.0347 2.2665 11.3022 2.45408 11.5311C2.64166 11.7599 2.87766 11.9442 3.14508 12.0708C3.41251 12.1974 3.70468 12.263 4.00055 12.2631H7.56055V16.2631C7.56055 16.7935 7.77126 17.3022 8.14633 17.6773C8.52141 18.0523 9.03011 18.2631 9.56055 18.2631C9.82576 18.2631 10.0801 18.1577 10.2677 17.9702C10.4552 17.7826 10.5605 17.5283 10.5605 17.2631V16.5961C10.5605 15.7306 10.8413 14.8884 11.3605 14.1961L12.7605 12.3301C13.2798 11.6377 13.5605 10.7955 13.5605 9.93006Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconCommentReply(props: Partial<Svg>) {
  return (
    <Svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4167 3.7572H4.58333C4.0971 3.7572 3.63079 3.95036 3.28697 4.29417C2.94315 4.63799 2.75 5.10431 2.75 5.59054V19.3405L5.92808 16.9572C6.24543 16.7192 6.6314 16.5905 7.02808 16.5905H17.4167C17.9029 16.5905 18.3692 16.3974 18.713 16.0536C19.0568 15.7097 19.25 15.2434 19.25 14.7572V5.59054C19.25 5.10431 19.0568 4.63799 18.713 4.29417C18.3692 3.95036 17.9029 3.7572 17.4167 3.7572Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconArrowShewron(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 14.2631L12 9.26306L7 14.2631"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconTravelCase(props: Partial<Svg>) {
  return (
    <Svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9 5.90864V6.40864H15.4H17.1V20.8086H4.9V6.40864H6.6H7.1V5.90864V4.80864C7.1 4.35777 7.27911 3.92537 7.59792 3.60656C7.91673 3.28775 8.34913 3.10864 8.8 3.10864H13.2C13.6509 3.10864 14.0833 3.28775 14.4021 3.60656C14.7209 3.92537 14.9 4.35777 14.9 4.80864V5.90864ZM8.8 4.30864H8.3V4.80864V5.90864V6.40864H8.8H13.2H13.7V5.90864V4.80864V4.30864H13.2H8.8ZM19.2 6.40864H19.8C20.2509 6.40864 20.6833 6.58775 21.0021 6.90656C21.3209 7.22537 21.5 7.65777 21.5 8.10864V19.1086C21.5 19.5595 21.3209 19.9919 21.0021 20.3107C20.6833 20.6295 20.2509 20.8086 19.8 20.8086H19.2V6.40864ZM2.8 6.40864V20.8086H2.2C1.74913 20.8086 1.31673 20.6295 0.997918 20.3107C0.679107 19.9919 0.5 19.5595 0.5 19.1086V8.10864C0.5 7.17478 1.26614 6.40864 2.2 6.40864H2.8Z"
        fill="white"
        stroke="white"
      />
    </Svg>
  );
}

export function IconUpdate(props: Partial<Svg>) {
  return (
    <Svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_2832_2880" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.86567 11.465C2.86567 15.9295 6.1026 18.9714 9.73847 19.6006C9.83737 19.6177 9.93193 19.6542 10.0167 19.7079C10.1016 19.7615 10.175 19.8314 10.2328 19.9135C10.2906 19.9955 10.3317 20.0882 10.3537 20.1861C10.3757 20.284 10.3782 20.3853 10.3611 20.4842C10.3439 20.5831 10.3075 20.6777 10.2538 20.7625C10.2001 20.8473 10.1302 20.9207 10.0482 20.9786C9.96612 21.0364 9.87348 21.0775 9.77555 21.0995C9.67762 21.1215 9.5763 21.124 9.4774 21.1068C5.20794 20.3676 1.3374 16.7684 1.3374 11.465C1.3374 9.21071 2.3626 7.43897 3.5594 6.09257C4.4174 5.12751 5.3986 4.34284 6.18767 3.74297H3.7882C3.59371 3.74297 3.40718 3.66571 3.26966 3.52818C3.13213 3.39066 3.05487 3.20413 3.05487 3.00964C3.05487 2.81515 3.13213 2.62862 3.26966 2.49109C3.40718 2.35357 3.59371 2.27631 3.7882 2.27631H8.1882C8.38269 2.27631 8.56922 2.35357 8.70675 2.49109C8.84427 2.62862 8.92154 2.81515 8.92154 3.00964V7.40964C8.92154 7.60413 8.84427 7.79066 8.70675 7.92818C8.56922 8.06571 8.38269 8.14297 8.1882 8.14297C7.99371 8.14297 7.80718 8.06571 7.66966 7.92818C7.53213 7.79066 7.45487 7.60413 7.45487 7.40964V4.70217L7.4534 4.70511C6.61447 5.33577 5.59074 6.10871 4.7034 7.10751C3.65474 8.28671 2.86567 9.71377 2.86567 11.465ZM19.1574 12.059C19.1574 7.64137 15.9894 4.61857 12.4005 3.94391C12.3004 3.92693 12.2048 3.89021 12.1191 3.83588C12.0334 3.78155 11.9594 3.7107 11.9014 3.62747C11.8434 3.54423 11.8025 3.45027 11.7812 3.35108C11.7599 3.25189 11.7586 3.14944 11.7772 3.04972C11.7959 2.95 11.8343 2.855 11.8901 2.77027C11.9459 2.68553 12.018 2.61276 12.1023 2.55619C12.1865 2.49963 12.2811 2.4604 12.3807 2.4408C12.4802 2.4212 12.5827 2.42162 12.6821 2.44204C16.8973 3.23404 20.6857 6.81271 20.6857 12.059C20.6857 14.3132 19.6605 16.0835 18.4637 17.4314C17.6057 18.3964 16.6245 19.1811 15.8354 19.781H18.2349C18.4294 19.781 18.6159 19.8582 18.7534 19.9958C18.8909 20.1333 18.9682 20.3198 18.9682 20.5143C18.9682 20.7088 18.8909 20.8953 18.7534 21.0329C18.6159 21.1704 18.4294 21.2476 18.2349 21.2476H13.8349C13.6404 21.2476 13.4538 21.1704 13.3163 21.0329C13.1788 20.8953 13.1015 20.7088 13.1015 20.5143V16.1143C13.1015 15.9198 13.1788 15.7333 13.3163 15.5958C13.4538 15.4582 13.6404 15.381 13.8349 15.381C14.0294 15.381 14.2159 15.4582 14.3534 15.5958C14.4909 15.7333 14.5682 15.9198 14.5682 16.1143V18.8203H14.5711C15.4086 18.1867 16.4338 17.4152 17.3197 16.415C18.3683 15.2372 19.1574 13.8116 19.1574 12.059Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.86567 11.465C2.86567 15.9295 6.1026 18.9714 9.73847 19.6006C9.83737 19.6177 9.93193 19.6542 10.0167 19.7079C10.1016 19.7615 10.175 19.8314 10.2328 19.9135C10.2906 19.9955 10.3317 20.0882 10.3537 20.1861C10.3757 20.284 10.3782 20.3853 10.3611 20.4842C10.3439 20.5831 10.3075 20.6777 10.2538 20.7625C10.2001 20.8473 10.1302 20.9207 10.0482 20.9786C9.96612 21.0364 9.87348 21.0775 9.77555 21.0995C9.67762 21.1215 9.5763 21.124 9.4774 21.1068C5.20794 20.3676 1.3374 16.7684 1.3374 11.465C1.3374 9.21071 2.3626 7.43897 3.5594 6.09257C4.4174 5.12751 5.3986 4.34284 6.18767 3.74297H3.7882C3.59371 3.74297 3.40718 3.66571 3.26966 3.52818C3.13213 3.39066 3.05487 3.20413 3.05487 3.00964C3.05487 2.81515 3.13213 2.62862 3.26966 2.49109C3.40718 2.35357 3.59371 2.27631 3.7882 2.27631H8.1882C8.38269 2.27631 8.56922 2.35357 8.70675 2.49109C8.84427 2.62862 8.92154 2.81515 8.92154 3.00964V7.40964C8.92154 7.60413 8.84427 7.79066 8.70675 7.92818C8.56922 8.06571 8.38269 8.14297 8.1882 8.14297C7.99371 8.14297 7.80718 8.06571 7.66966 7.92818C7.53213 7.79066 7.45487 7.60413 7.45487 7.40964V4.70217L7.4534 4.70511C6.61447 5.33577 5.59074 6.10871 4.7034 7.10751C3.65474 8.28671 2.86567 9.71377 2.86567 11.465ZM19.1574 12.059C19.1574 7.64137 15.9894 4.61857 12.4005 3.94391C12.3004 3.92693 12.2048 3.89021 12.1191 3.83588C12.0334 3.78155 11.9594 3.7107 11.9014 3.62747C11.8434 3.54423 11.8025 3.45027 11.7812 3.35108C11.7599 3.25189 11.7586 3.14944 11.7772 3.04972C11.7959 2.95 11.8343 2.855 11.8901 2.77027C11.9459 2.68553 12.018 2.61276 12.1023 2.55619C12.1865 2.49963 12.2811 2.4604 12.3807 2.4408C12.4802 2.4212 12.5827 2.42162 12.6821 2.44204C16.8973 3.23404 20.6857 6.81271 20.6857 12.059C20.6857 14.3132 19.6605 16.0835 18.4637 17.4314C17.6057 18.3964 16.6245 19.1811 15.8354 19.781H18.2349C18.4294 19.781 18.6159 19.8582 18.7534 19.9958C18.8909 20.1333 18.9682 20.3198 18.9682 20.5143C18.9682 20.7088 18.8909 20.8953 18.7534 21.0329C18.6159 21.1704 18.4294 21.2476 18.2349 21.2476H13.8349C13.6404 21.2476 13.4538 21.1704 13.3163 21.0329C13.1788 20.8953 13.1015 20.7088 13.1015 20.5143V16.1143C13.1015 15.9198 13.1788 15.7333 13.3163 15.5958C13.4538 15.4582 13.6404 15.381 13.8349 15.381C14.0294 15.381 14.2159 15.4582 14.3534 15.5958C14.4909 15.7333 14.5682 15.9198 14.5682 16.1143V18.8203H14.5711C15.4086 18.1867 16.4338 17.4152 17.3197 16.415C18.3683 15.2372 19.1574 13.8116 19.1574 12.059Z"
        stroke="currentColor" // #11B559
        strokeWidth="2"
        mask="url(#path-1-inside-1_2832_2880)"
      />
    </Svg>
  );
}

export function IconTrash(props: Partial<Svg>) {
  return (
    <Svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.908 10.846V16.346M9.24133 10.846V16.346M5.57467 7.17936V18.1794C5.57467 18.6656 5.76782 19.1319 6.11164 19.4757C6.45545 19.8195 6.92177 20.0127 7.408 20.0127H14.7413C15.2276 20.0127 15.6939 19.8195 16.0377 19.4757C16.3815 19.1319 16.5747 18.6656 16.5747 18.1794V7.17936M3.74133 7.17936H18.408M6.49133 7.17936L8.32467 3.5127H13.8247L15.658 7.17936"
        stroke="currentColor" // #11B559
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconInformation(props: Partial<Svg>) {
  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 9.40869H11.5V7.40869H13.5M13.5 17.4087H11.5V11.4087H13.5M12.5 2.40869C11.1868 2.40869 9.88642 2.66735 8.67317 3.1699C7.45991 3.67244 6.35752 4.40904 5.42893 5.33762C3.55357 7.21299 2.5 9.75653 2.5 12.4087C2.5 15.0609 3.55357 17.6044 5.42893 19.4798C6.35752 20.4083 7.45991 21.1449 8.67317 21.6475C9.88642 22.15 11.1868 22.4087 12.5 22.4087C15.1522 22.4087 17.6957 21.3551 19.5711 19.4798C21.4464 17.6044 22.5 15.0609 22.5 12.4087C22.5 11.0955 22.2413 9.79511 21.7388 8.58186C21.2362 7.3686 20.4997 6.26621 19.5711 5.33762C18.6425 4.40904 17.5401 3.67244 16.3268 3.1699C15.1136 2.66735 13.8132 2.40869 12.5 2.40869Z"
        fill="#D28E27"
      />
    </Svg>
  );
}
export function IconChecked(props: Partial<Svg>) {
  return (
    <Svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4949 0.895701C17.7165 0.76241 17.9811 0.720135 18.2332 0.777749C18.4853 0.835363 18.7052 0.988386 18.8469 1.2047L19.8369 2.7147C19.966 2.91196 20.0212 3.14847 19.9928 3.38249C19.9645 3.6165 19.8544 3.83298 19.6819 3.9937L19.6789 3.9977L19.6649 4.0107L19.6079 4.0637L19.3829 4.2787C18.138 5.48636 16.9307 6.73229 15.7629 8.0147C13.5659 10.4307 10.9569 13.5927 9.20091 16.6607C8.71091 17.5167 7.51391 17.7007 6.80391 16.9617L0.318913 10.2237C0.225978 10.1271 0.153413 10.0128 0.10553 9.88761C0.0576464 9.76241 0.0354232 9.62886 0.0401809 9.4949C0.0449385 9.36094 0.0765798 9.2293 0.133224 9.10781C0.189869 8.98632 0.27036 8.87746 0.369913 8.7877L2.32991 7.0197C2.50215 6.86441 2.72301 6.77381 2.95469 6.76342C3.18637 6.75302 3.41445 6.82347 3.59991 6.9627L6.90891 9.4437C12.0779 4.3467 15.0089 2.3907 17.4949 0.895701Z"
        fill="white"
      />
    </Svg>
  );
}
export function IconReport(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 5.24641C4.00002 5.11343 4.02656 4.98178 4.07807 4.85918C4.12959 4.73659 4.20503 4.62549 4.3 4.53241C5.38984 3.46404 6.84585 2.85114 8.37166 2.81844C9.89746 2.78574 11.3784 3.33571 12.513 4.35641L12.864 4.68441C13.5934 5.3235 14.5302 5.67583 15.5 5.67583C16.4698 5.67583 17.4066 5.3235 18.136 4.68441L18.385 4.45741C18.995 3.97441 19.912 4.36041 19.995 5.13341L20 5.24641V14.2464C20 14.3794 19.9734 14.511 19.9219 14.6336C19.8704 14.7562 19.795 14.8673 19.7 14.9604C18.6102 16.0288 17.1542 16.6417 15.6283 16.6744C14.1025 16.7071 12.6216 16.1571 11.487 15.1364L11.136 14.8084C10.4295 14.1894 9.52777 13.8388 8.58872 13.8179C7.64967 13.7971 6.73323 14.1074 6 14.6944V21.2464C5.99972 21.5013 5.90212 21.7464 5.72715 21.9318C5.55218 22.1171 5.31305 22.2286 5.05861 22.2436C4.80416 22.2585 4.55362 22.1757 4.35817 22.0121C4.16271 21.8486 4.0371 21.6165 4.007 21.3634L4 21.2464V5.24641Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function IconAddress(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 11.7464C11.337 11.7464 10.7011 11.483 10.2322 11.0142C9.76339 10.5453 9.5 9.90944 9.5 9.2464C9.5 8.58336 9.76339 7.94747 10.2322 7.47863C10.7011 7.00979 11.337 6.7464 12 6.7464C12.663 6.7464 13.2989 7.00979 13.7678 7.47863C14.2366 7.94747 14.5 8.58336 14.5 9.2464C14.5 9.5747 14.4353 9.89979 14.3097 10.2031C14.1841 10.5064 13.9999 10.782 13.7678 11.0142C13.5356 11.2463 13.26 11.4305 12.9567 11.5561C12.6534 11.6817 12.3283 11.7464 12 11.7464ZM12 2.2464C10.1435 2.2464 8.36301 2.9839 7.05025 4.29665C5.7375 5.60941 5 7.38988 5 9.2464C5 14.4964 12 22.2464 12 22.2464C12 22.2464 19 14.4964 19 9.2464C19 7.38988 18.2625 5.60941 16.9497 4.29665C15.637 2.9839 13.8565 2.2464 12 2.2464Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function IconPhone(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.23 15.5064L16.69 15.2164C16.3914 15.1813 16.0886 15.2144 15.8046 15.3131C15.5206 15.4118 15.2626 15.5736 15.05 15.7864L13.21 17.6264C10.3714 16.1823 8.0641 13.875 6.62004 11.0364L8.47004 9.1864C8.90004 8.7564 9.11004 8.1564 9.04004 7.5464L8.75004 5.0264C8.69356 4.53849 8.45951 4.08842 8.0925 3.76199C7.7255 3.43556 7.25121 3.25559 6.76004 3.2564H5.03004C3.90004 3.2564 2.96004 4.1964 3.03004 5.3264C3.56004 13.8664 10.39 20.6864 18.92 21.2164C20.05 21.2864 20.99 20.3464 20.99 19.2164V17.4864C21 16.4764 20.24 15.6264 19.23 15.5064Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function IconClock(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2.2464C17.523 2.2464 22 6.7234 22 12.2464C22 17.7694 17.523 22.2464 12 22.2464C6.477 22.2464 2 17.7694 2 12.2464C2 6.7234 6.477 2.2464 12 2.2464ZM12 6.2464C11.7348 6.2464 11.4804 6.35176 11.2929 6.53929C11.1054 6.72683 11 6.98118 11 7.2464V12.2464C11.0001 12.5116 11.1055 12.7659 11.293 12.9534L14.293 15.9534C14.4816 16.1356 14.7342 16.2364 14.9964 16.2341C15.2586 16.2318 15.5094 16.1266 15.6948 15.9412C15.8802 15.7558 15.9854 15.505 15.9877 15.2428C15.99 14.9806 15.8892 14.728 15.707 14.5394L13 11.8324V7.2464C13 6.98118 12.8946 6.72683 12.7071 6.53929C12.5196 6.35176 12.2652 6.2464 12 6.2464Z"
        fill="currentColor"
      />
    </Svg>
  );
}
export function IconInternet(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.4102 8.8864V8.8364C20.7056 6.91263 19.4271 5.25169 17.7477 4.07827C16.0683 2.90485 14.0689 2.27557 12.0202 2.27557C9.97145 2.27557 7.97213 2.90485 6.29271 4.07827C4.61328 5.25169 3.3348 6.91263 2.6302 8.8364C2.6302 8.8364 2.6302 8.8364 2.6302 8.8864C1.84332 11.0573 1.84332 13.4355 2.6302 15.6064V15.6564C3.3348 17.5802 4.61328 19.2411 6.29271 20.4145C7.97213 21.588 9.97145 22.2172 12.0202 22.2172C14.0689 22.2172 16.0683 21.588 17.7477 20.4145C19.4271 19.2411 20.7056 17.5802 21.4102 15.6564C21.4102 15.6564 21.4102 15.6564 21.4102 15.6064C22.1971 13.4355 22.1971 11.0573 21.4102 8.8864ZM4.2602 14.2464C3.9125 12.9357 3.9125 11.5571 4.2602 10.2464H6.1202C5.95994 11.5749 5.95994 12.9179 6.1202 14.2464H4.2602ZM5.0802 16.2464H6.4802C6.71366 17.1387 7.04921 18.001 7.4802 18.8164C6.49949 18.1483 5.67969 17.2705 5.0802 16.2464ZM6.4802 8.2464H5.0802C5.67107 7.22549 6.48039 6.34787 7.4502 5.6764C7.02955 6.49311 6.70409 7.35543 6.4802 8.2464ZM11.0002 19.9464C9.77196 19.0451 8.90934 17.7316 8.5702 16.2464H11.0002V19.9464ZM11.0002 14.2464H8.1402C7.95411 12.9196 7.95411 11.5732 8.1402 10.2464H11.0002V14.2464ZM11.0002 8.2464H8.5702C8.90934 6.76117 9.77196 5.44772 11.0002 4.5464V8.2464ZM18.9202 8.2464H17.5202C17.2867 7.35415 16.9512 6.49179 16.5202 5.6764C17.5009 6.34447 18.3207 7.22234 18.9202 8.2464ZM13.0002 4.5464C14.2284 5.44772 15.091 6.76117 15.4302 8.2464H13.0002V4.5464ZM13.0002 19.9464V16.2464H15.4302C15.091 17.7316 14.2284 19.0451 13.0002 19.9464ZM15.8602 14.2464H13.0002V10.2464H15.8602C16.0463 11.5732 16.0463 12.9196 15.8602 14.2464ZM16.5502 18.8164C16.9812 18.001 17.3167 17.1387 17.5502 16.2464H18.9502C18.3507 17.2705 17.5309 18.1483 16.5502 18.8164ZM19.7402 14.2464H17.8802C17.9619 13.5829 18.002 12.9149 18.0002 12.2464C18.002 11.5779 17.9619 10.9099 17.8802 10.2464H19.7402C20.0879 11.5571 20.0879 12.9357 19.7402 14.2464Z"
        fill="currentColor"
      />
    </Svg>
  );
}

export function IconUploadImage(props: Partial<Svg>) {
  return (
    <Svg
      width="32"
      height="34"
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9998 2.49457C16.1442 2.49447 16.2869 2.52662 16.4181 2.58881C16.5493 2.651 16.6659 2.74175 16.7598 2.85482L20.7598 7.66732C20.9324 7.87518 21.0178 8.14523 20.9973 8.41804C20.9768 8.69086 20.8521 8.94411 20.6505 9.12207C20.4489 9.30003 20.1871 9.38813 19.9225 9.36698C19.658 9.34584 19.4124 9.21718 19.2398 9.00932L16.9998 6.31432V21.4008C16.9998 21.6743 16.8945 21.9366 16.7069 22.13C16.5194 22.3234 16.2651 22.4321 15.9998 22.4321C15.7346 22.4321 15.4803 22.3234 15.2927 22.13C15.1052 21.9366 14.9998 21.6743 14.9998 21.4008V6.31294L12.7598 9.00932C12.6744 9.11224 12.5701 9.1968 12.453 9.25817C12.3359 9.31954 12.2081 9.35651 12.0771 9.36698C11.9462 9.37745 11.8144 9.36121 11.6895 9.31919C11.5646 9.27717 11.449 9.21019 11.3492 9.12207C11.2494 9.03395 11.1674 8.92642 11.1079 8.80563C11.0484 8.68483 11.0125 8.55313 11.0023 8.41804C10.9922 8.28296 11.0079 8.14713 11.0487 8.01832C11.0894 7.88951 11.1544 7.77024 11.2398 7.66732L15.2398 2.85482C15.3338 2.74175 15.4504 2.651 15.5816 2.58881C15.7128 2.52662 15.8554 2.49447 15.9998 2.49457ZM9.32784 12.1223C9.59305 12.1209 9.84797 12.2281 10.0365 12.4205C10.225 12.6128 10.3318 12.8746 10.3332 13.1481C10.3346 13.4216 10.2306 13.6845 10.044 13.8789C9.85751 14.0733 9.60372 14.1834 9.3385 14.1848C7.88117 14.1931 6.84784 14.2316 6.0625 14.3801C5.30784 14.5244 4.86917 14.7541 4.54517 15.0882C4.17584 15.4691 3.93584 16.0039 3.80384 17.0132C3.66917 18.0513 3.6665 19.4277 3.6665 21.4008V22.7758C3.6665 24.7503 3.66917 26.1267 3.80384 27.1648C3.93584 28.1741 4.17717 28.7076 4.54517 29.0898C4.9145 29.4693 5.43184 29.7168 6.41184 29.8529C7.41717 29.9932 8.75317 29.9946 10.6665 29.9946H21.3332C23.2465 29.9946 24.5812 29.9932 25.5892 29.8529C26.5678 29.7168 27.0852 29.4693 27.4545 29.0884C27.8238 28.7076 28.0638 28.1741 28.1958 27.1648C28.3305 26.1267 28.3332 24.7503 28.3332 22.7758V21.4008C28.3332 19.4277 28.3305 18.0513 28.1958 17.0118C28.0638 16.0039 27.8225 15.4691 27.4545 15.0882C27.1292 14.7541 26.6918 14.5244 25.9372 14.3801C25.1518 14.2316 24.1185 14.1931 22.6612 14.1848C22.5299 14.1841 22.4 14.1567 22.2789 14.1042C22.1578 14.0517 22.048 13.9752 21.9556 13.8789C21.8633 13.7826 21.7902 13.6685 21.7406 13.5431C21.691 13.4177 21.6658 13.2835 21.6665 13.1481C21.6672 13.0126 21.6938 12.8787 21.7447 12.7538C21.7956 12.629 21.8698 12.5157 21.9632 12.4205C22.0565 12.3252 22.1672 12.2499 22.2887 12.1987C22.4103 12.1476 22.5405 12.1216 22.6718 12.1223C24.1145 12.1306 25.3158 12.1663 26.2985 12.3519C27.3092 12.5444 28.1692 12.9088 28.8692 13.6307C29.6718 14.4571 30.0158 15.5007 30.1785 16.7382C30.3332 17.9289 30.3332 19.4456 30.3332 21.3252V22.8514C30.3332 24.7324 30.3332 26.2477 30.1785 27.4398C30.0158 28.6773 29.6718 29.7196 28.8692 30.5473C28.0665 31.3751 27.0558 31.7298 25.8558 31.8976C24.6998 32.0571 23.2292 32.0571 21.4065 32.0571H10.5932C8.7705 32.0571 7.29984 32.0571 6.14384 31.8976C4.94384 31.7312 3.93317 31.3751 3.1305 30.5473C2.32784 29.7196 1.98384 28.6773 1.8225 27.4398C1.6665 26.2477 1.6665 24.7311 1.6665 22.8514V21.3252C1.6665 19.4456 1.6665 17.9289 1.8225 16.7368C1.9825 15.4993 2.32917 14.4571 3.1305 13.6293C3.8305 12.9088 4.6905 12.5431 5.70117 12.3519C6.68384 12.1663 7.88517 12.1306 9.32784 12.1223Z"
        fill="black"
        fillOpacity="0.4"
      />
    </Svg>
  );
}

export function IconFilter(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.523 4.99977C14.1878 4.51503 9.81216 4.51503 5.477 4.99977C5.23207 5.02701 4.99897 5.11967 4.80219 5.26803C4.6054 5.41639 4.45218 5.61498 4.35859 5.84297C4.265 6.07095 4.2345 6.31993 4.27029 6.56376C4.30608 6.80759 4.40685 7.0373 4.562 7.22877L8.331 11.8878C9.41067 13.2224 9.99979 14.8871 10 16.6038V19.7458C9.99992 19.8636 10.0276 19.9797 10.0807 20.0848C10.1339 20.1899 10.2111 20.281 10.306 20.3508L13.077 22.3828C13.1635 22.4462 13.2658 22.4844 13.3726 22.4931C13.4795 22.5019 13.5867 22.4809 13.6823 22.4324C13.7779 22.3839 13.8582 22.3098 13.9143 22.2185C13.9704 22.1271 14.0001 22.022 14 21.9148V16.6038C14.0003 14.8866 14.5898 13.2216 15.67 11.8868L19.438 7.22677C19.5929 7.03529 19.6934 6.80568 19.7291 6.56199C19.7647 6.3183 19.7342 6.06951 19.6406 5.84169C19.547 5.61387 19.3939 5.41541 19.1973 5.26711C19.0007 5.11881 18.7678 5.02712 18.523 4.99977Z"
        fill="black"
      />
    </Svg>
  );
}

export function IconMarker(props: Partial<Svg>) {
  return (
    <Svg
      width="45"
      height="53"
      viewBox="0 0 45 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.5 51.7084L8.75001 37.9584C5.63659 35.1737 3.44209 31.5093 2.45689 27.45C1.47169 23.3908 1.74223 19.1281 3.2327 15.226C4.72317 11.3239 7.36333 7.96629 10.8038 5.59752C14.2443 3.22875 18.3229 1.96045 22.5 1.96045C26.6771 1.96045 30.7557 3.22875 34.1962 5.59752C37.6367 7.96629 40.2768 11.3239 41.7673 15.226C43.2578 19.1281 43.5283 23.3908 42.5431 27.45C41.5579 31.5093 39.3634 35.1737 36.25 37.9584L22.5 51.7084Z"
        fill="white"
        stroke="#11B559"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function IconInstagram(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.25C12.7293 9.25 13.4286 9.53994 13.9443 10.0557C14.4601 10.5714 14.75 11.2707 14.75 12C14.75 12.7293 14.4601 13.4286 13.9443 13.9443C13.4286 14.4601 12.7293 14.75 12 14.75C11.2707 14.75 10.5714 14.4601 10.0557 13.9443C9.53994 13.4286 9.25 12.7293 9.25 12L9.26367 11.7285C9.32612 11.0989 9.60433 10.507 10.0557 10.0557C10.5714 9.53994 11.2707 9.25 12 9.25Z"
        fill="white"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.2281 2.15772C10.0644 1.73274 13.9359 1.73274 17.7721 2.15772C19.868 2.39169 21.5576 4.04163 21.8037 6.14517C22.2584 10.0351 22.2584 13.9648 21.8037 17.8548C21.5576 19.9583 19.868 21.6082 17.7733 21.8433C13.9366 22.2684 10.0647 22.2684 6.2281 21.8433C4.13229 21.6082 2.44262 19.9583 2.19651 17.8559C1.74179 13.9655 1.74179 10.0355 2.19651 6.14517C2.44262 4.04163 4.13229 2.39169 6.2281 2.15772ZM17.5183 5.37814C17.2256 5.37814 16.9449 5.49441 16.7379 5.70139C16.5309 5.90836 16.4147 6.18907 16.4147 6.48178C16.4147 6.77448 16.5309 7.05519 16.7379 7.26217C16.9449 7.46914 17.2256 7.58541 17.5183 7.58541C17.811 7.58541 18.0917 7.46914 18.2987 7.26217C18.5057 7.05519 18.6219 6.77448 18.6219 6.48178C18.6219 6.18907 18.5057 5.90836 18.2987 5.70139C18.0917 5.49441 17.811 5.37814 17.5183 5.37814ZM6.75784 12C6.75784 10.6096 7.31015 9.27623 8.29327 8.29311C9.27639 7.31 10.6098 6.75769 12.0001 6.75769C13.3905 6.75769 14.7239 7.31 15.707 8.29311C16.6901 9.27623 17.2424 10.6096 17.2424 12C17.2424 13.3903 16.6901 14.7237 15.707 15.7068C14.7239 16.6899 13.3905 17.2422 12.0001 17.2422C10.6098 17.2422 9.27639 16.6899 8.29327 15.7068C7.31015 14.7237 6.75784 13.3903 6.75784 12Z"
        fill="white"
      />
    </Svg>
  );
}
export function IconWhatsAppOutlined(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9624 3.18359C9.74786 3.19256 7.66586 4.00533 6.05127 5.4834L5.73389 5.78809C4.07738 7.4589 3.17466 9.67778 3.18408 12.04L3.18994 12.3086C3.2342 13.5573 3.54269 14.7915 4.09326 15.9062L4.21533 16.1426L4.30908 16.3174V19.6914H7.68213L7.85791 19.7852C9.03364 20.4119 10.3548 20.7632 11.6929 20.8105L11.9604 20.8164H12.0005C14.1998 20.8164 16.2754 20.0211 17.895 18.5664L18.2124 18.2666C19.8809 16.6124 20.8076 14.4001 20.8218 12.04L20.813 11.5928C20.7726 10.701 20.6 9.8324 20.2983 8.99902L20.1372 8.58496C19.7494 7.66013 19.2105 6.81698 18.5376 6.07617L18.2407 5.76465C17.5276 5.05148 16.7127 4.47404 15.812 4.04395L15.4204 3.86816C14.3374 3.41319 13.1879 3.18365 12.0034 3.18359H11.9624ZM8.34619 7.22266L8.83447 7.23145C8.85757 7.23282 8.88139 7.23344 8.90186 7.2334C8.92333 7.23336 8.94298 7.23328 8.9624 7.23438C9.00042 7.23654 9.03595 7.24249 9.0708 7.25879C9.12183 7.28273 9.18686 7.33544 9.2583 7.46191L9.33154 7.61426V7.61523C9.43927 7.87402 9.62148 8.32075 9.78564 8.71973C9.94842 9.11533 10.0964 9.47119 10.1313 9.54102C10.1907 9.65978 10.2189 9.77235 10.1538 9.90625C9.91415 10.3841 9.66875 10.6125 9.50635 10.7861C9.42744 10.8705 9.35299 10.957 9.32568 11.0605C9.30366 11.1443 9.31458 11.228 9.35205 11.3174L9.39795 11.4092C9.90338 12.2768 10.4105 12.8651 10.9849 13.332C11.5578 13.7977 12.1948 14.1406 12.9546 14.5205V14.5195C13.0889 14.5873 13.2116 14.6246 13.3286 14.6104C13.4496 14.5956 13.5459 14.5284 13.6304 14.4307L13.6294 14.4297C13.7456 14.2976 14.0537 13.9383 14.2749 13.6543L14.4575 13.4062L14.4585 13.4053C14.5337 13.2901 14.5972 13.2587 14.6538 13.252C14.6874 13.248 14.7245 13.2514 14.7681 13.2617L14.9233 13.3125L14.9253 13.3135C15.038 13.3538 15.4086 13.5271 15.7905 13.7109L16.6782 14.1475L16.6802 14.1484C16.8126 14.2128 16.9136 14.2572 16.9937 14.3018C17.0334 14.3239 17.0628 14.3433 17.0845 14.3613L17.1294 14.4121L17.1304 14.4141C17.1304 14.4141 17.1314 14.4165 17.1333 14.4219C17.1352 14.4274 17.138 14.4354 17.1401 14.4453C17.1445 14.4653 17.1484 14.4923 17.1509 14.5254C17.1559 14.5921 17.155 14.6802 17.146 14.7852C17.1325 14.943 17.0997 15.1359 17.0405 15.3467L16.9722 15.5625C16.8767 15.8342 16.5902 16.1087 16.2485 16.3281C15.994 16.4916 15.7227 16.6159 15.5054 16.6826L15.3091 16.7295C14.9067 16.7893 14.552 16.8037 14.0972 16.7178C13.7539 16.6529 13.3515 16.5303 12.8267 16.3242L12.2593 16.0889C10.3351 15.2563 8.91206 13.5974 8.26318 12.7432L7.88232 12.2178C7.8177 12.1293 7.56006 11.7847 7.31787 11.3066C7.07377 10.8248 6.85014 10.2156 6.8501 9.60254C6.8501 8.37374 7.49113 7.77194 7.72803 7.51172L7.729 7.5127C7.94427 7.28044 8.19531 7.22266 8.34619 7.22266ZM2.72314 16.7109L2.7124 16.6904C1.99037 15.2602 1.60512 13.6602 1.59814 12.0488L1.60889 11.5225C1.65537 10.4751 1.85586 9.45295 2.20654 8.47363L2.39502 7.9873C2.91039 6.74538 3.65525 5.63092 4.60498 4.67188C5.43581 3.83293 6.38948 3.15238 7.44385 2.64062L7.90186 2.43164C9.02309 1.95227 10.207 1.67881 11.4282 1.61328L11.9546 1.59766H12.0005C13.2239 1.59766 14.4152 1.80546 15.5493 2.2168L16.0317 2.40527C17.1247 2.86236 18.1179 3.49787 18.9917 4.29199L19.3589 4.6416C20.1981 5.48287 20.8785 6.4451 21.3872 7.50781L21.5952 7.96875C22.1362 9.25978 22.4098 10.6327 22.4028 12.0469L22.3872 12.5723C22.331 13.6191 22.1227 14.6383 21.7622 15.6143L21.5698 16.0986C21.1087 17.1815 20.4733 18.1666 19.6792 19.0322L19.3286 19.3955C18.4916 20.2264 17.5322 20.8993 16.4731 21.4014L16.0132 21.6055C14.7432 22.1325 13.3944 22.4023 12.0034 22.4023H11.9546C10.3433 22.3954 8.7431 22.01 7.31299 21.2881L7.2915 21.2773H3.70361C3.1623 21.2773 2.72314 20.8382 2.72314 20.2969V16.7109Z"
        fill="#F4F6FA"
        stroke="white"
        strokeWidth="0.195312"
      />
    </Svg>
  );
}
export function IconYoutubeFilled(props: Partial<Svg>) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0732 5.14062C12.1213 5.14073 12.1924 5.14117 12.2832 5.1416C12.465 5.14246 12.7267 5.14404 13.0459 5.14746C13.6851 5.15432 14.5545 5.1679 15.4736 5.19531C16.3934 5.22275 17.3596 5.264 18.1953 5.3252C18.833 5.3719 19.3712 5.42896 19.751 5.49512L20.0752 5.56445C20.4357 5.66175 20.7645 5.85203 21.0283 6.11621C21.259 6.34728 21.4333 6.6276 21.5381 6.93555L21.5791 7.06934C21.783 7.83173 21.8914 9.04851 21.9463 10.1104C21.9733 10.6335 21.9864 11.1067 21.9932 11.4492C21.9965 11.6204 21.9982 11.7593 21.999 11.8545C21.9994 11.9017 21.9999 11.9382 22 11.9629V12.0371C21.9999 12.0618 21.9994 12.0983 21.999 12.1455C21.9982 12.2407 21.9965 12.3796 21.9932 12.5508C21.9864 12.8933 21.9733 13.3665 21.9463 13.8896C21.8983 14.819 21.8085 15.8669 21.6504 16.625L21.5791 16.9307V16.9316C21.3958 17.6181 20.8781 18.1677 20.2119 18.3945L20.0762 18.4355H20.0752C19.7177 18.5316 19.045 18.6126 18.1953 18.6748C17.3596 18.736 16.3934 18.7773 15.4736 18.8047C14.5545 18.8321 13.6851 18.8457 13.0459 18.8525C12.7267 18.856 12.465 18.8575 12.2832 18.8584C12.1924 18.8588 12.1213 18.8593 12.0732 18.8594H11.9268C11.8787 18.8593 11.8076 18.8588 11.7168 18.8584C11.535 18.8575 11.2733 18.856 10.9541 18.8525C10.3149 18.8457 9.44553 18.8321 8.52637 18.8047C7.60659 18.7773 6.64037 18.736 5.80469 18.6748C5.16703 18.6281 4.62884 18.571 4.24902 18.5049L3.9248 18.4355H3.92383C3.23997 18.2526 2.68994 17.7337 2.46289 17.0664L2.4209 16.9316V16.9307C2.21701 16.1683 2.10858 14.9515 2.05371 13.8896C2.02668 13.3665 2.01361 12.8933 2.00684 12.5508C2.00345 12.3796 2.00182 12.2407 2.00098 12.1455C2.00056 12.0983 2.0001 12.0618 2 12.0371V11.9629C2.0001 11.9382 2.00056 11.9017 2.00098 11.8545C2.00182 11.7593 2.00345 11.6204 2.00684 11.4492C2.01361 11.1066 2.02667 10.6329 2.05371 10.1094C2.10173 9.17999 2.19147 8.13206 2.34961 7.37305L2.4209 7.06641C2.50535 6.75084 2.66159 6.45968 2.87598 6.21484L2.97168 6.11328C3.2355 5.84913 3.56428 5.65846 3.9248 5.56152L3.92383 5.56055C4.28156 5.46492 4.95433 5.3861 5.80371 5.32422C6.63955 5.26333 7.60641 5.22261 8.52637 5.19531C9.44555 5.16804 10.3149 5.15429 10.9541 5.14746C11.2733 5.14405 11.535 5.14245 11.7168 5.1416C11.8076 5.14118 11.8786 5.14073 11.9268 5.14062H12.0732ZM9.41406 16.0098L10.166 15.5732L15.6035 12.4092L16.3516 11.9736L15.6006 11.543L10.1631 8.42578L9.41406 7.99609V16.0098Z"
        fill="#F4F6FA"
        stroke="white"
      />
    </Svg>
  );
}

export function IconTwiter(props: Partial<Svg>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.01746 3.1124C3.47703 3.1124 2.22461 4.36482 2.22461 5.90525V19.8695C2.22461 21.41 3.47703 22.6624 5.01746 22.6624H18.9817C20.5222 22.6624 21.7746 21.41 21.7746 19.8695V5.90525C21.7746 4.36482 20.5222 3.1124 18.9817 3.1124H5.01746ZM17.9824 6.77802L13.4528 11.9535L18.781 18.9968H14.6092L11.345 14.7246L7.60522 18.9968H5.5324L10.3763 13.4591L5.2662 6.77802H9.54276L12.4971 10.6837L15.9096 6.77802H17.9824ZM16.3329 17.7574L8.91873 7.95189H7.68377L15.1808 17.7574H16.3285H16.3329Z"
        fill="white"
      />
    </svg>
  );
}

export function IconWhatsFacebook(props: Partial<Svg>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2842 12.8881C22.2842 7.21149 17.6771 2.6044 12.0005 2.6044C6.32389 2.6044 1.7168 7.21149 1.7168 12.8881C1.7168 17.8654 5.25439 22.0097 9.94375 22.9661V15.9732H7.88701V12.8881H9.94375V10.3172C9.94375 8.33242 11.5583 6.71788 13.543 6.71788H16.114V9.80298H14.0572C13.4916 9.80298 13.0289 10.2658 13.0289 10.8314V12.8881H16.114V15.9732H13.0289V23.1204C18.2221 22.6062 22.2842 18.2253 22.2842 12.8881Z"
        fill="white"
      />
    </svg>
  );
}
export function IconWhatsLinkedin(props: Partial<Svg>) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.303 3.13739H6.697C5.51758 3.13739 4.38647 3.60591 3.5525 4.43989C2.71852 5.27386 2.25 6.40497 2.25 7.58439V18.1904C2.25 19.3698 2.71852 20.5009 3.5525 21.3349C4.38647 22.1689 5.51758 22.6374 6.697 22.6374H17.303C18.4824 22.6374 19.6135 22.1689 20.4475 21.3349C21.2815 20.5009 21.75 19.3698 21.75 18.1904V7.58439C21.75 6.40497 21.2815 5.27386 20.4475 4.43989C19.6135 3.60591 18.4824 3.13739 17.303 3.13739ZM8.843 18.8794C8.84614 18.9338 8.83811 18.9883 8.81942 19.0395C8.80072 19.0908 8.77176 19.1376 8.7343 19.1772C8.69684 19.2168 8.65167 19.2484 8.60158 19.2699C8.55149 19.2914 8.49752 19.3025 8.443 19.3024H6.663C6.55566 19.2998 6.45362 19.2551 6.37883 19.1781C6.30403 19.1011 6.26244 18.9978 6.263 18.8904V11.4874C6.26153 11.4339 6.27079 11.3807 6.29023 11.3309C6.30967 11.2811 6.3389 11.2357 6.3762 11.1974C6.41349 11.1591 6.45808 11.1286 6.50734 11.1079C6.5566 11.0871 6.60953 11.0764 6.663 11.0764H8.443C8.49647 11.0764 8.5494 11.0871 8.59866 11.1079C8.64792 11.1286 8.69251 11.1591 8.7298 11.1974C8.7671 11.2357 8.79633 11.2811 8.81577 11.3309C8.83521 11.3807 8.84447 11.4339 8.843 11.4874V18.8794ZM7.52 9.51939C7.32729 9.51795 7.13674 9.47856 6.95925 9.40347C6.78176 9.32839 6.62079 9.21908 6.48554 9.08179C6.35029 8.9445 6.24341 8.78191 6.171 8.60332C6.09858 8.42472 6.06206 8.2336 6.0635 8.04089C6.06494 7.84818 6.10433 7.65763 6.17942 7.48014C6.2545 7.30265 6.36381 7.14168 6.5011 7.00643C6.63839 6.87118 6.80098 6.7643 6.97957 6.69189C7.15817 6.61947 7.34929 6.58295 7.542 6.58439C7.92452 6.59683 8.28703 6.75826 8.55219 7.03425C8.81734 7.31023 8.96415 7.67891 8.96128 8.06162C8.9584 8.44433 8.80609 8.81076 8.53682 9.08274C8.26755 9.35471 7.90266 9.51069 7.52 9.51739M18.337 18.8674C18.3365 18.9684 18.2969 19.0653 18.2264 19.1377C18.1558 19.2101 18.06 19.2523 17.959 19.2554H16.08C15.9788 19.2523 15.8828 19.21 15.8123 19.1374C15.7418 19.0648 15.7022 18.9676 15.702 18.8664V15.4424C15.702 14.9314 15.858 13.2194 14.346 13.2194C13.167 13.2194 12.934 14.4194 12.889 14.9534V18.9444C12.889 19.0458 12.8496 19.1432 12.779 19.216C12.7085 19.2888 12.6123 19.3313 12.511 19.3344H10.688C10.5847 19.3341 10.4858 19.2929 10.4129 19.2198C10.34 19.1467 10.299 19.0477 10.299 18.9444V11.4514C10.3021 11.35 10.3446 11.2539 10.4174 11.1833C10.4902 11.1128 10.5876 11.0733 10.689 11.0734H12.511C12.6124 11.0733 12.7098 11.1128 12.7826 11.1833C12.8554 11.2539 12.8979 11.35 12.901 11.4514V12.0964C13.167 11.707 13.5343 11.3977 13.9633 11.2017C14.3922 11.0057 14.8665 10.9306 15.335 10.9844C18.37 10.9844 18.359 13.8194 18.359 15.4314L18.337 18.8674Z"
        fill="white"
      />
    </svg>
  );
}
export function IconPeopleCommunity(props: Partial<Svg>) {
  return (
    <Svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9999 9.99999C30.5854 9.99999 29.2289 10.5619 28.2287 11.5621C27.2285 12.5623 26.6666 13.9188 26.6666 15.3333C26.6666 16.7478 27.2285 18.1044 28.2287 19.1046C29.2289 20.1048 30.5854 20.6667 31.9999 20.6667C33.4144 20.6667 34.771 20.1048 35.7712 19.1046C36.7713 18.1044 37.3333 16.7478 37.3333 15.3333C37.3333 13.9188 36.7713 12.5623 35.7712 11.5621C34.771 10.5619 33.4144 9.99999 31.9999 9.99999ZM23.3333 15.3333C23.3333 13.0348 24.2463 10.8304 25.8717 9.20506C27.497 7.57975 29.7014 6.66666 31.9999 6.66666C34.2985 6.66666 36.5029 7.57975 38.1282 9.20506C39.7535 10.8304 40.6666 13.0348 40.6666 15.3333C40.6666 17.6319 39.7535 19.8363 38.1282 21.4616C36.5029 23.0869 34.2985 24 31.9999 24C29.7014 24 27.497 23.0869 25.8717 21.4616C24.2463 19.8363 23.3333 17.6319 23.3333 15.3333ZM12.6666 15.3333C11.6057 15.3333 10.5883 15.7548 9.83816 16.5049C9.08801 17.255 8.66659 18.2725 8.66659 19.3333C8.66659 20.3942 9.08801 21.4116 9.83816 22.1618C10.5883 22.9119 11.6057 23.3333 12.6666 23.3333C13.7275 23.3333 14.7449 22.9119 15.495 22.1618C16.2452 21.4116 16.6666 20.3942 16.6666 19.3333C16.6666 18.2725 16.2452 17.255 15.495 16.5049C14.7449 15.7548 13.7275 15.3333 12.6666 15.3333ZM5.33325 19.3333C5.33325 17.3884 6.10587 15.5231 7.48114 14.1479C8.8564 12.7726 10.7217 12 12.6666 12C14.6115 12 16.4768 12.7726 17.852 14.1479C19.2273 15.5231 19.9999 17.3884 19.9999 19.3333C19.9999 21.2782 19.2273 23.1435 17.852 24.5188C16.4768 25.894 14.6115 26.6667 12.6666 26.6667C10.7217 26.6667 8.8564 25.894 7.48114 24.5188C6.10587 23.1435 5.33325 21.2782 5.33325 19.3333ZM47.3333 19.3333C47.3333 18.2725 47.7547 17.255 48.5048 16.5049C49.255 15.7548 50.2724 15.3333 51.3333 15.3333C52.3941 15.3333 53.4115 15.7548 54.1617 16.5049C54.9118 17.255 55.3333 18.2725 55.3333 19.3333C55.3333 20.3942 54.9118 21.4116 54.1617 22.1618C53.4115 22.9119 52.3941 23.3333 51.3333 23.3333C50.2724 23.3333 49.255 22.9119 48.5048 22.1618C47.7547 21.4116 47.3333 20.3942 47.3333 19.3333ZM51.3333 12C49.3883 12 47.5231 12.7726 46.1478 14.1479C44.7725 15.5231 43.9999 17.3884 43.9999 19.3333C43.9999 21.2782 44.7725 23.1435 46.1478 24.5188C47.5231 25.894 49.3883 26.6667 51.3333 26.6667C53.2782 26.6667 55.1434 25.894 56.5187 24.5188C57.894 23.1435 58.6666 21.2782 58.6666 19.3333C58.6666 17.3884 57.894 15.5231 56.5187 14.1479C55.1434 12.7726 53.2782 12 51.3333 12ZM19.9999 32.3333C19.9999 31.1841 20.4565 30.0819 21.2691 29.2692C22.0818 28.4565 23.184 28 24.3333 28H39.6666C40.8159 28 41.9181 28.4565 42.7307 29.2692C43.5434 30.0819 43.9999 31.1841 43.9999 32.3333V42.6667C43.9999 45.8493 42.7356 48.9015 40.4852 51.1519C38.2348 53.4024 35.1825 54.6667 31.9999 54.6667C28.8173 54.6667 25.7651 53.4024 23.5146 51.1519C21.2642 48.9015 19.9999 45.8493 19.9999 42.6667V32.3333ZM24.3333 31.3333C24.068 31.3333 23.8137 31.4387 23.6261 31.6262C23.4386 31.8138 23.3333 32.0681 23.3333 32.3333V42.6667C23.3333 44.9652 24.2463 47.1696 25.8717 48.7949C27.497 50.4202 29.7014 51.3333 31.9999 51.3333C34.2985 51.3333 36.5029 50.4202 38.1282 48.7949C39.7535 47.1696 40.6666 44.9652 40.6666 42.6667V32.3333C40.6666 32.0681 40.5612 31.8138 40.3737 31.6262C40.1862 31.4387 39.9318 31.3333 39.6666 31.3333H24.3333ZM17.5359 30.6533C17.4017 31.192 17.3341 31.752 17.3333 32.3333V34.1573L9.41325 36.28C9.15732 36.3487 8.93914 36.5163 8.80664 36.7458C8.67414 36.9753 8.63815 37.248 8.70659 37.504L10.6906 44.9093C11.2312 46.9282 12.4833 48.6838 14.216 49.8525C15.9488 51.0212 18.0455 51.5244 20.1199 51.2693C20.8797 52.3183 21.775 53.2621 22.7826 54.076C22.5808 54.1427 22.3764 54.2031 22.1693 54.2573C20.6471 54.6655 19.0594 54.7698 17.4969 54.5643C15.9344 54.3588 14.4276 53.8476 13.0627 53.0597C11.6978 52.2719 10.5014 51.2229 9.54192 49.9727C8.58242 48.7225 7.87858 47.2956 7.47059 45.7733L5.48525 38.368C5.33807 37.8183 5.30061 37.245 5.37501 36.6808C5.4494 36.1166 5.6342 35.5726 5.91884 35.0798C6.20349 34.587 6.5824 34.1551 7.03396 33.8088C7.48552 33.4625 8.00087 33.2085 8.55059 33.0613L17.5359 30.6533ZM41.2159 54.076C41.4186 54.1427 41.6235 54.2031 41.8306 54.2573C43.3528 54.6652 44.9404 54.7693 46.5028 54.5637C48.0653 54.358 49.5719 53.8466 50.9367 53.0587C52.3015 52.2707 53.4977 51.2217 54.457 49.9714C55.4164 48.7212 56.1201 47.2942 56.5279 45.772L58.5119 38.3667C58.8092 37.2566 58.6534 36.074 58.0788 35.0788C57.5042 34.0837 56.5579 33.3575 55.4479 33.06L46.4639 30.652C46.5981 31.1915 46.6657 31.7515 46.6666 32.332V34.1587L54.5853 36.2787C54.7123 36.3127 54.8313 36.3714 54.9356 36.4515C55.0399 36.5316 55.1274 36.6315 55.193 36.7454C55.2586 36.8594 55.3012 36.9851 55.3181 37.1155C55.3351 37.2459 55.3262 37.3784 55.2919 37.5053L53.3079 44.9093C52.7673 46.928 51.5155 48.6833 49.783 49.852C48.0505 51.0207 45.9541 51.524 43.8799 51.2693C43.1202 52.3183 42.2235 53.2621 41.2159 54.076Z"
        fill="#282C35"
      />
    </Svg>
  );
}
export function IconTransparency(props: Partial<Svg>) {
  return (
    <Svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.6666 24C42.6666 28.9507 40.6999 33.6987 37.1992 37.1993C33.6986 40.7 28.9506 42.6667 23.9999 42.6667C19.0492 42.6667 14.3013 40.7 10.8006 37.1993C7.29991 33.6987 5.33325 28.9507 5.33325 24C5.33325 19.0493 7.29991 14.3014 10.8006 10.8007C14.3013 7.3 19.0492 5.33334 23.9999 5.33334C28.9506 5.33334 33.6986 7.3 37.1992 10.8007C40.6999 14.3014 42.6666 19.0493 42.6666 24Z"
        stroke="#282C35"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4025 41.6187C21.1613 38.8503 21.5413 36.063 22.5147 33.4602C23.4881 30.8574 25.0303 28.5047 27.0288 26.5739C29.0273 24.6431 31.4317 23.1829 34.0665 22.2998C36.7013 21.4167 39.5001 21.1329 42.2585 21.4694M50.6585 24.6747C52.8997 26.2342 54.7715 28.2664 56.1419 30.628C57.5124 32.9896 58.348 35.623 58.59 38.3427C58.832 41.0624 58.4744 43.802 57.5424 46.3684C56.6104 48.9349 55.1268 51.2656 53.1961 53.1963C51.2654 55.127 48.9347 56.6106 46.3682 57.5426C43.8018 58.4745 41.0622 58.8321 38.3425 58.5902C35.6228 58.3482 32.9894 57.5125 30.6278 56.1421C28.2662 54.7717 26.234 52.8999 24.6745 50.6587M17.3332 6.66669L41.3332 30.6667M6.6665 17.3334L30.6665 41.3334"
        stroke="#282C35"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
export function IconComments(props: Partial<Svg>) {
  return (
    <Svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3333 10.6667C16.6186 10.6667 9.33325 17.1173 9.33325 25.3333C9.33325 28.592 10.4933 31.592 12.4319 34.0133L10.7146 40.3147C10.6534 40.5547 10.6598 40.8069 10.733 41.0435C10.8061 41.2801 10.9433 41.4919 11.1292 41.6555C11.3151 41.8191 11.5427 41.9281 11.7867 41.9706C12.0307 42.013 12.2817 41.9872 12.5119 41.896L19.9786 38.7867C20.305 38.6505 20.5639 38.3903 20.6984 38.0632C20.833 37.7362 20.8321 37.369 20.6959 37.0427C20.5598 36.7163 20.2995 36.4573 19.9725 36.3228C19.6454 36.1883 19.2783 36.1892 18.9519 36.3253L14.0026 38.3867L15.1893 34.04C15.2475 33.8265 15.2517 33.6018 15.2014 33.3862C15.1511 33.1707 15.048 32.971 14.9013 32.8053C13.0746 30.7413 11.9999 28.1467 11.9999 25.3333C11.9999 18.824 17.8479 13.3333 25.3333 13.3333C31.4933 13.3333 36.5599 17.0613 38.1466 22.008C29.6666 22.2587 22.6666 28.6133 22.6666 36.6667C22.6666 44.8827 29.9519 51.3333 38.6666 51.3333C40.6585 51.3357 42.6359 50.9947 44.5119 50.3253L51.4879 53.232C52.4906 53.648 53.5733 52.6987 53.2853 51.648L51.5679 45.3467C53.5641 42.8934 54.6579 39.8294 54.6666 36.6667C54.6666 29.1813 48.6213 23.1627 40.9546 22.1493C39.3546 15.504 32.8933 10.6667 25.3333 10.6667ZM25.3333 36.6667C25.3333 30.1573 31.1813 24.6667 38.6666 24.6667C46.1519 24.6667 51.9999 30.1573 51.9999 36.6667C51.9999 39.48 50.9253 42.0747 49.0986 44.1387C48.9519 44.3044 48.8487 44.504 48.7984 44.7196C48.7482 44.9351 48.7523 45.1598 48.8106 45.3733L49.9973 49.72L45.0479 47.6587C44.7267 47.5249 44.3659 47.522 44.0426 47.6507C42.3302 48.3235 40.5065 48.6682 38.6666 48.6667C31.1813 48.6667 25.3333 43.1787 25.3333 36.6667Z"
        fill="#282C35"
      />
    </Svg>
  );
}

export function IconSearch(props: Partial<Svg>) {
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 19L15 15M17 9C17 11.1217 16.1571 13.1566 14.6569 14.6569C13.1566 16.1571 11.1217 17 9 17C6.87827 17 4.84344 16.1571 3.34315 14.6569C1.84285 13.1566 1 11.1217 1 9C1 6.87827 1.84285 4.84344 3.34315 3.34315C4.84344 1.84285 6.87827 1 9 1C11.1217 1 13.1566 1.84285 14.6569 3.34315C16.1571 4.84344 17 6.87827 17 9Z"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
export function IconSelectArrow(props: Partial<Svg>) {
  return (
    <Svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1L6 6L11 1"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

// export function Icon

export default Svg;
